var items = {
  "block.minecraft.acacia_button": "Akasíuhnappur",
  "block.minecraft.acacia_door": "Akasíuviðarhurð",
  "block.minecraft.acacia_fence": "Akasíugirðing",
  "block.minecraft.acacia_fence_gate": "Akasíuhlið",
  "block.minecraft.acacia_hanging_sign": "Hangandi akasíuskilti",
  "block.minecraft.acacia_leaves": "Akasíulauf",
  "block.minecraft.acacia_log": "Akasíudrumbur",
  "block.minecraft.acacia_planks": "Akasíuplankar",
  "block.minecraft.acacia_pressure_plate": "Þrýstihella úr akasíu",
  "block.minecraft.acacia_sapling": "Akasíugræðlingur",
  "block.minecraft.acacia_shelf": "Akasíuhilla",
  "block.minecraft.acacia_sign": "Akasíuskilti",
  "block.minecraft.acacia_slab": "Akasíuhella",
  "block.minecraft.acacia_stairs": "Akasíutröppur",
  "block.minecraft.acacia_trapdoor": "Akasíuhleri",
  "block.minecraft.acacia_wall_hanging_sign": "Vegghangandi akasíuskilti",
  "block.minecraft.acacia_wall_sign": "Akasíuskilti á vegg",
  "block.minecraft.acacia_wood": "Akasíuviður",
  "block.minecraft.activator_rail": "Virkjunarteinn",
  "block.minecraft.air": "Loft",
  "block.minecraft.allium": "Villilaukur",
  "block.minecraft.amethyst_block": "Blákvarskubbur",
  "block.minecraft.amethyst_cluster": "Blákvarsklasi",
  "block.minecraft.ancient_debris": "Fornleifar",
  "block.minecraft.andesite": "Andesít",
  "block.minecraft.andesite_slab": "Andesíthella",
  "block.minecraft.andesite_stairs": "Andesíttröppur",
  "block.minecraft.andesite_wall": "Andesítveggur",
  "block.minecraft.anvil": "Steðji",
  "block.minecraft.attached_melon_stem": "Tengdur melónustilkur",
  "block.minecraft.attached_pumpkin_stem": "Tengdur graskersstilkur",
  "block.minecraft.azalea": "Lyngrós",
  "block.minecraft.azalea_leaves": "Lyngrósablöð",
  "block.minecraft.azure_bluet": "Blámaðra",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambuskubbur",
  "block.minecraft.bamboo_button": "Bambushnappur",
  "block.minecraft.bamboo_door": "Bambushurð",
  "block.minecraft.bamboo_fence": "Bambusgirðing",
  "block.minecraft.bamboo_fence_gate": "Bambushlið",
  "block.minecraft.bamboo_hanging_sign": "Hangandi bambusskilti",
  "block.minecraft.bamboo_mosaic": "Bambusmósaík",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmósaíkhella",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmósaíktröppur",
  "block.minecraft.bamboo_planks": "Bambusplankar",
  "block.minecraft.bamboo_pressure_plate": "Þrýstihella úr bambusviði",
  "block.minecraft.bamboo_sapling": "Bambussproti",
  "block.minecraft.bamboo_shelf": "Bambushilla",
  "block.minecraft.bamboo_sign": "Bambusskilti",
  "block.minecraft.bamboo_slab": "Bambushella",
  "block.minecraft.bamboo_stairs": "Bambuströppur",
  "block.minecraft.bamboo_trapdoor": "Bambushleri",
  "block.minecraft.bamboo_wall_hanging_sign": "Vegghangandi bambusskilti",
  "block.minecraft.bamboo_wall_sign": "Bambusveggskilti",
  "block.minecraft.banner.base.black": "Alsvartur grunnur",
  "block.minecraft.banner.base.blue": "Alblár grunnur",
  "block.minecraft.banner.base.brown": "Albrúnn grunnur",
  "block.minecraft.banner.base.cyan": "Alheiðblár grunnur",
  "block.minecraft.banner.base.gray": "Algrár grunnur",
  "block.minecraft.banner.base.green": "Algrænn grunnur",
  "block.minecraft.banner.base.light_blue": "Alljósblár grunnur",
  "block.minecraft.banner.base.light_gray": "Alljósgrár grunnur",
  "block.minecraft.banner.base.lime": "Alljósgrænn grunnur",
  "block.minecraft.banner.base.magenta": "Alvínrauður grunnur",
  "block.minecraft.banner.base.orange": "Alappelsínugulur grunnur",
  "block.minecraft.banner.base.pink": "Albleikur grunnur",
  "block.minecraft.banner.base.purple": "Alfjólublár grunnur",
  "block.minecraft.banner.base.red": "Alrauður grunnur",
  "block.minecraft.banner.base.white": "Alhvítur grunnur",
  "block.minecraft.banner.base.yellow": "Algulur grunnur",
  "block.minecraft.banner.border.black": "Svartur Rammi",
  "block.minecraft.banner.border.blue": "Blár Rammi",
  "block.minecraft.banner.border.brown": "Brúnn Rammi",
  "block.minecraft.banner.border.cyan": "Blágrænn Rammi",
  "block.minecraft.banner.border.gray": "Grár Rammi",
  "block.minecraft.banner.border.green": "Grænn Rammi",
  "block.minecraft.banner.border.light_blue": "Ljósblár Rammi",
  "block.minecraft.banner.border.light_gray": "Ljósgrár Rammi",
  "block.minecraft.banner.border.lime": "Ljósgrænn Rammi",
  "block.minecraft.banner.border.magenta": "Vínrauður rammi",
  "block.minecraft.banner.border.orange": "Appelsínugulur Rammi",
  "block.minecraft.banner.border.pink": "Bleikur Rammi",
  "block.minecraft.banner.border.purple": "Fjólublár Rammi",
  "block.minecraft.banner.border.red": "Rauður Rammi",
  "block.minecraft.banner.border.white": "Hvítur Rammi",
  "block.minecraft.banner.border.yellow": "Gulur Rammi",
  "block.minecraft.banner.bricks.black": "Svartur akur borði",
  "block.minecraft.banner.bricks.blue": "Blár akur borði",
  "block.minecraft.banner.bricks.brown": "Brúnn akur borði",
  "block.minecraft.banner.bricks.cyan": "Cyan Akur Borði",
  "block.minecraft.banner.bricks.gray": "Grár akur borði",
  "block.minecraft.banner.bricks.green": "Grænn akur borði",
  "block.minecraft.banner.bricks.light_blue": "Ljósblár akur borði",
  "block.minecraft.banner.bricks.light_gray": "Ljósgrár akur borði",
  "block.minecraft.banner.bricks.lime": "Kalk akur borði",
  "block.minecraft.banner.bricks.magenta": "Vínrautt múrsteinsmynstur",
  "block.minecraft.banner.bricks.orange": "Appelsínugulur akur borði",
  "block.minecraft.banner.bricks.pink": "Bleikur akur borði",
  "block.minecraft.banner.bricks.purple": "Fjólublátt akur borði",
  "block.minecraft.banner.bricks.red": "Rautt akur borði",
  "block.minecraft.banner.bricks.white": "Hvítur litur akur borði",
  "block.minecraft.banner.bricks.yellow": "Gulur akur borði",
  "block.minecraft.banner.circle.black": "Svartur roundel",
  "block.minecraft.banner.circle.blue": "Bláir Roundel",
  "block.minecraft.banner.circle.brown": "Brún umferð",
  "block.minecraft.banner.circle.cyan": "Blágrænt Roundel",
  "block.minecraft.banner.circle.gray": "Grátt Roundel",
  "block.minecraft.banner.circle.green": "Grænt roundel",
  "block.minecraft.banner.circle.light_blue": "Ljósblár Roundel",
  "block.minecraft.banner.circle.light_gray": "Ljósgrátt Roundel",
  "block.minecraft.banner.circle.lime": "Gulgrænt Roundel",
  "block.minecraft.banner.circle.magenta": "Vínrauð skífa",
  "block.minecraft.banner.circle.orange": "Appelsínugulur Roundel",
  "block.minecraft.banner.circle.pink": "Bleikur Roundel",
  "block.minecraft.banner.circle.purple": "Fjólublátt Roundel",
  "block.minecraft.banner.circle.red": "Rautt roundel",
  "block.minecraft.banner.circle.white": "Hvítur Roundel",
  "block.minecraft.banner.circle.yellow": "Gulur Roundel",
  "block.minecraft.banner.creeper.black": "Svart laumpúkatákn",
  "block.minecraft.banner.creeper.blue": "Blátt laumupúkamynstur",
  "block.minecraft.banner.creeper.brown": "Brúnt laumpúkatákn",
  "block.minecraft.banner.creeper.cyan": "Blágrænt laumupúkamynstur",
  "block.minecraft.banner.creeper.gray": "Grátt laumupúkamynstur",
  "block.minecraft.banner.creeper.green": "Grænt laumpúkatákn",
  "block.minecraft.banner.creeper.light_blue": "Ljósblátt laumupúkamynstur",
  "block.minecraft.banner.creeper.light_gray": "Ljósgrátt laumupúkamynstur",
  "block.minecraft.banner.creeper.lime": "Gulgrænt laumupúkamynstur",
  "block.minecraft.banner.creeper.magenta": "Vínrautt laumupúkamynstur",
  "block.minecraft.banner.creeper.orange": "Appelsínugult laumupúkamynstur",
  "block.minecraft.banner.creeper.pink": "Bleikt laumupúkamynstur",
  "block.minecraft.banner.creeper.purple": "Fjólublátt laumupúkamynstur",
  "block.minecraft.banner.creeper.red": "Rautt laumpúkatákn",
  "block.minecraft.banner.creeper.white": "Hvítt laumupúkamynstur",
  "block.minecraft.banner.creeper.yellow": "Gult laumupúkamynstur",
  "block.minecraft.banner.cross.black": "Svartur skákross",
  "block.minecraft.banner.cross.blue": "Blár skákross",
  "block.minecraft.banner.cross.brown": "Brúnn skákross",
  "block.minecraft.banner.cross.cyan": "Heiðblár skákross",
  "block.minecraft.banner.cross.gray": "Grár skákross",
  "block.minecraft.banner.cross.green": "Grænn skákross",
  "block.minecraft.banner.cross.light_blue": "Ljósblár skákross",
  "block.minecraft.banner.cross.light_gray": "Ljósgrár skákross",
  "block.minecraft.banner.cross.lime": "Gulgrænn skákross",
  "block.minecraft.banner.cross.magenta": "Vínrauður skákross",
  "block.minecraft.banner.cross.orange": "Appelsínugulur skákross",
  "block.minecraft.banner.cross.pink": "Bleikur skákross",
  "block.minecraft.banner.cross.purple": "Fjólublár skákross",
  "block.minecraft.banner.cross.red": "Rauður skákross",
  "block.minecraft.banner.cross.white": "Hvítur skákross",
  "block.minecraft.banner.cross.yellow": "Gulur skákross",
  "block.minecraft.banner.curly_border.black": "Svartur Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.blue": "Blár Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.brown": "Brúnn Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.cyan": "Blárgrænn Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.gray": "Grár Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.green": "Grænn Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.light_blue": "Ljósblár Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.light_gray": "Ljósgrár Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.lime": "Límona Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.magenta": "Fjólublár Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.orange": "Appelsínugulur Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.pink": "Bleikur Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.purple": "Fjólublár Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.red": "Rauður Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.white": "Hvítur Vogskorinn Rammi",
  "block.minecraft.banner.curly_border.yellow": "Gulur Vogskorinn Rammi",
  "block.minecraft.banner.diagonal_left.black": "Svartur þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.blue": "Blár þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.brown": "Brúnn þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.cyan": "Heiðblár þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.gray": "Grár þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.green": "Grænn þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljósblár þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljósgrár þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.lime": "Gulgrænn þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.magenta": "Vínrauður þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.orange": "Appelsínugulur þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.pink": "Bleikur þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.purple": "Fjólublár þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.red": "Rauður þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.white": "Hvítur þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.yellow": "Gulur þríhyrningur uppi til vinstri",
  "block.minecraft.banner.diagonal_right.black": "Svartur þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.blue": "Blár þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.brown": "Brúnn þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.cyan": "Heiðblár þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.gray": "Grár þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.green": "Grænn þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.light_blue": "Ljósblár þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljósgrár þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.lime": "Gulgrænn þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.magenta": "Vínrauður þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.orange": "Appelsínugulur þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.pink": "Bleikur þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.purple": "Fjólublár",
  "block.minecraft.banner.diagonal_right.red": "Rauður þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.white": "Hvítur þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_right.yellow": "Gulur þríhyrningur uppi til hægri",
  "block.minecraft.banner.diagonal_up_left.black": "Svartur þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.blue": "Blár þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.brown": "Brúnn þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.cyan": "Heiðblár þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.gray": "Grár þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.green": "Grænn þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ljósblár þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ljósgrár",
  "block.minecraft.banner.diagonal_up_left.lime": "Gulgrænn þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.magenta": "Vínrauður þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.orange": "Appelsínugulur þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.pink": "Bleikur þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.purple": "Fjólublár þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.red": "Rauður þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.white": "Hvítur þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gulur þríhyrningur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_right.black": "Svartur þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.blue": "Blár þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.brown": "Brúnn þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.cyan": "Heiðblár þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.gray": "Grár þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.green": "Grænn þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljósblár þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljósgrár þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.lime": "Gulgrænn þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.magenta": "Vínrauður þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.orange": "Appelsínugulur þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.pink": "Bleikur þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.purple": "Fjólublár þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.red": "Rauður þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.white": "Hvítur þríhyrningur niðri til hægri",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gulur þríhyrningur niðri til hægri",
  "block.minecraft.banner.flow.black": "Svart Flæði",
  "block.minecraft.banner.flow.blue": "Blátt Flæði",
  "block.minecraft.banner.flow.brown": "Brúnt Flæði",
  "block.minecraft.banner.flow.cyan": "Blágrænnt Flæði",
  "block.minecraft.banner.flow.gray": "Grátt Flæði",
  "block.minecraft.banner.flow.green": "Grænt Flæði",
  "block.minecraft.banner.flow.light_blue": "Ljósblátt Flæði",
  "block.minecraft.banner.flow.light_gray": "Ljósgrátt Flæði",
  "block.minecraft.banner.flow.lime": "Ljósgrænt flæði",
  "block.minecraft.banner.flow.magenta": "Vínrautt Flæði",
  "block.minecraft.banner.flow.orange": "Appelsínugult Flæði",
  "block.minecraft.banner.flow.pink": "Bleikt Flæði",
  "block.minecraft.banner.flow.purple": "Fjólublátt Flæði",
  "block.minecraft.banner.flow.red": "Rautt Flæði",
  "block.minecraft.banner.flow.white": "Hvítt Flæði",
  "block.minecraft.banner.flow.yellow": "Gult Flæði",
  "block.minecraft.banner.flower.black": "Svart blómatákn",
  "block.minecraft.banner.flower.blue": "Blátt blómatákn",
  "block.minecraft.banner.flower.brown": "Brúnt blómatákn",
  "block.minecraft.banner.flower.cyan": "Heiðblátt blómatákn",
  "block.minecraft.banner.flower.gray": "Grátt blómatákn",
  "block.minecraft.banner.flower.green": "Grænt blómatákn",
  "block.minecraft.banner.flower.light_blue": "Ljósblátt blómagjald",
  "block.minecraft.banner.flower.light_gray": "Ljósgrátt blómatákn",
  "block.minecraft.banner.flower.lime": "Gulgrænt blómatákn",
  "block.minecraft.banner.flower.magenta": "Vínrautt blómamerki",
  "block.minecraft.banner.flower.orange": "Appelsínugult blómagjald",
  "block.minecraft.banner.flower.pink": "Bleikt blómatákn",
  "block.minecraft.banner.flower.purple": "Fjólublátt blómatákn",
  "block.minecraft.banner.flower.red": "Rautt blómatákn",
  "block.minecraft.banner.flower.white": "Hvít blómagjald",
  "block.minecraft.banner.flower.yellow": "Gult blómagjald",
  "block.minecraft.banner.globe.black": "Svartur hnöttur",
  "block.minecraft.banner.globe.blue": "Blár hnöttur",
  "block.minecraft.banner.globe.brown": "Brúnn hnöttur",
  "block.minecraft.banner.globe.cyan": "Ljósblár hnöttur",
  "block.minecraft.banner.globe.gray": "Grár hnöttur",
  "block.minecraft.banner.globe.green": "Grænn hnöttur",
  "block.minecraft.banner.globe.light_blue": "Ljósblár hnöttur",
  "block.minecraft.banner.globe.light_gray": "Ljósgrár hnöttur",
  "block.minecraft.banner.globe.lime": "Ljósgrænn hnöttur",
  "block.minecraft.banner.globe.magenta": "Blárauður hnöttur",
  "block.minecraft.banner.globe.orange": "Appelsín hnöttur",
  "block.minecraft.banner.globe.pink": "Bleikur hnöttur",
  "block.minecraft.banner.globe.purple": "Fjólublár hnöttur",
  "block.minecraft.banner.globe.red": "Rauður hnöttur",
  "block.minecraft.banner.globe.white": "Hvítur hnöttur",
  "block.minecraft.banner.globe.yellow": "Gulur hnöttur",
  "block.minecraft.banner.gradient.black": "Svart halli",
  "block.minecraft.banner.gradient.blue": "Blár stigi",
  "block.minecraft.banner.gradient.brown": "Brúnn halli",
  "block.minecraft.banner.gradient.cyan": "Bláa halli",
  "block.minecraft.banner.gradient.gray": "Grár halli",
  "block.minecraft.banner.gradient.green": "Grænn halli",
  "block.minecraft.banner.gradient.light_blue": "Ljósblár litastigull",
  "block.minecraft.banner.gradient.light_gray": "Ljósgrár halli",
  "block.minecraft.banner.gradient.lime": "Gulgrænn litastigull",
  "block.minecraft.banner.gradient.magenta": "Vínrauður litastigull",
  "block.minecraft.banner.gradient.orange": "Appelsínugulur litastigull",
  "block.minecraft.banner.gradient.pink": "Bleikur litastigull",
  "block.minecraft.banner.gradient.purple": "Fjólublátt halli",
  "block.minecraft.banner.gradient.red": "Rauður halli",
  "block.minecraft.banner.gradient.white": "Hvítur litastigull",
  "block.minecraft.banner.gradient.yellow": "Gulur litastigull",
  "block.minecraft.banner.gradient_up.black": "Svartur litastigull neðst",
  "block.minecraft.banner.gradient_up.blue": "Blár litastigull neðst",
  "block.minecraft.banner.gradient_up.brown": "Brúnn litastigull neðst",
  "block.minecraft.banner.gradient_up.cyan": "Heiðblár litastigull neðst",
  "block.minecraft.banner.gradient_up.gray": "Grár litastigull neðst",
  "block.minecraft.banner.gradient_up.green": "Grænn litastigull neðst",
  "block.minecraft.banner.gradient_up.light_blue": "Ljósblár litastigull neðst",
  "block.minecraft.banner.gradient_up.light_gray": "Ljósgrár litastigull neðst",
  "block.minecraft.banner.gradient_up.lime": "Gulgrænn litastigull neðst",
  "block.minecraft.banner.gradient_up.magenta": "Vínrauður litastigull neðst",
  "block.minecraft.banner.gradient_up.orange": "Appelsínugulur litastigull neðst",
  "block.minecraft.banner.gradient_up.pink": "Bleikur litastigull neðst",
  "block.minecraft.banner.gradient_up.purple": "Fjólublár litastigull neðst",
  "block.minecraft.banner.gradient_up.red": "Rauður litastigull neðst",
  "block.minecraft.banner.gradient_up.white": "Hvítur litastigull neðst",
  "block.minecraft.banner.gradient_up.yellow": "Gulur litastigull neðst",
  "block.minecraft.banner.guster.black": "Svartur Gustur",
  "block.minecraft.banner.guster.blue": "Blár Gustur",
  "block.minecraft.banner.guster.brown": "Brúnn Gustur",
  "block.minecraft.banner.guster.cyan": "Blágrænn Gustur",
  "block.minecraft.banner.guster.gray": "Grár Gustur",
  "block.minecraft.banner.guster.green": "Grænn Gustur",
  "block.minecraft.banner.guster.light_blue": "Ljósblár Gustur",
  "block.minecraft.banner.guster.light_gray": "Ljósgrár Gustur",
  "block.minecraft.banner.guster.lime": "Ljósgrænn Gustur",
  "block.minecraft.banner.guster.magenta": "Vínrauður Gustur",
  "block.minecraft.banner.guster.orange": "Appelsínugulur Gustur",
  "block.minecraft.banner.guster.pink": "Bleikur Gustur",
  "block.minecraft.banner.guster.purple": "Fjólublár Gustur",
  "block.minecraft.banner.guster.red": "Rauður Gustur",
  "block.minecraft.banner.guster.white": "Hvítur Gustur",
  "block.minecraft.banner.guster.yellow": "Gulur Gustur",
  "block.minecraft.banner.half_horizontal.black": "Svartur efri helmingur",
  "block.minecraft.banner.half_horizontal.blue": "Blá þverrönd uppi",
  "block.minecraft.banner.half_horizontal.brown": "Brún þverrönd uppi",
  "block.minecraft.banner.half_horizontal.cyan": "Heiðblá þverrönd uppi",
  "block.minecraft.banner.half_horizontal.gray": "Grá þverrönd uppi",
  "block.minecraft.banner.half_horizontal.green": "Græn þverrönd uppi",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljósblá þverrönd uppi",
  "block.minecraft.banner.half_horizontal.light_gray": "Ljósgrá þverrönd uppi",
  "block.minecraft.banner.half_horizontal.lime": "Gulgræn þverrönd uppi",
  "block.minecraft.banner.half_horizontal.magenta": "Vínrauð þverrönd uppi",
  "block.minecraft.banner.half_horizontal.orange": "Appelsínugul þverrönd uppi",
  "block.minecraft.banner.half_horizontal.pink": "Bleik þverrönd uppi",
  "block.minecraft.banner.half_horizontal.purple": "Fjólublá þverrönd uppi",
  "block.minecraft.banner.half_horizontal.red": "Rauður efri helmingur",
  "block.minecraft.banner.half_horizontal.white": "Hvít þverrönd uppi",
  "block.minecraft.banner.half_horizontal.yellow": "Gul þverrönd uppi",
  "block.minecraft.banner.half_horizontal_bottom.black": "Svört þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blá þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brún þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Heiðblá þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grá þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.green": "Græn þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljósblá þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljósgrá þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Gulgræn þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Vínrauð þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Appelsínugul þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Bleik þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Fjólublá þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rauð þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.white": "Hvít þverrönd niðri",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gul þverrönd niðri",
  "block.minecraft.banner.half_vertical.black": "Svartur per föl",
  "block.minecraft.banner.half_vertical.blue": "Blár per föl",
  "block.minecraft.banner.half_vertical.brown": "Brúnn per föl",
  "block.minecraft.banner.half_vertical.cyan": "Blágrænt per föl",
  "block.minecraft.banner.half_vertical.gray": "Grátt per föl",
  "block.minecraft.banner.half_vertical.green": "Grænn per föl",
  "block.minecraft.banner.half_vertical.light_blue": "Ljósblár per föl",
  "block.minecraft.banner.half_vertical.light_gray": "Ljósgrátt per föl",
  "block.minecraft.banner.half_vertical.lime": "Gulgrænt per föl",
  "block.minecraft.banner.half_vertical.magenta": "Vínrauður vinstri helmingur",
  "block.minecraft.banner.half_vertical.orange": "Appelsínugulur per föl",
  "block.minecraft.banner.half_vertical.pink": "Bleikur per föl",
  "block.minecraft.banner.half_vertical.purple": "Fjólublár per föl",
  "block.minecraft.banner.half_vertical.red": "Rauður per föl",
  "block.minecraft.banner.half_vertical.white": "Hvítur per föl",
  "block.minecraft.banner.half_vertical.yellow": "Gulur per föl",
  "block.minecraft.banner.half_vertical_right.black": "Svört föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.blue": "Blá föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.brown": "Brún föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.cyan": "Grænblá föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.gray": "Grá föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.green": "Græn föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljós blá föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljós grá föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.lime": "Límóna föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.magenta": "Vínrauður hægri helmingur",
  "block.minecraft.banner.half_vertical_right.orange": "Appelsínugul föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.pink": "Bleik föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.purple": "Fjölublá föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.red": "Rauð föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.white": "Hvít föl á hvolfi",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul föl á hvolfi",
  "block.minecraft.banner.mojang.black": "Svartur hlutur",
  "block.minecraft.banner.mojang.blue": "Blár hlutur",
  "block.minecraft.banner.mojang.brown": "Brúnn hlutur",
  "block.minecraft.banner.mojang.cyan": "Sægrænn hlutur",
  "block.minecraft.banner.mojang.gray": "Grár hlutur",
  "block.minecraft.banner.mojang.green": "Grænn hlutur",
  "block.minecraft.banner.mojang.light_blue": "Ljósblár hlutur",
  "block.minecraft.banner.mojang.light_gray": "Ljósgrár hlutur",
  "block.minecraft.banner.mojang.lime": "Neongrænn hlutur",
  "block.minecraft.banner.mojang.magenta": "Vínrauður hlutur",
  "block.minecraft.banner.mojang.orange": "Appelsínugulur hlutur",
  "block.minecraft.banner.mojang.pink": "Bleikur hlutur",
  "block.minecraft.banner.mojang.purple": "Fjólublár hlutur",
  "block.minecraft.banner.mojang.red": "Rauður hlutur",
  "block.minecraft.banner.mojang.white": "Hvítur hlutur",
  "block.minecraft.banner.mojang.yellow": "Gulur hlutur",
  "block.minecraft.banner.piglin.black": "Svart trýni",
  "block.minecraft.banner.piglin.blue": "Blátt Trýni",
  "block.minecraft.banner.piglin.brown": "Brúnt Trýni",
  "block.minecraft.banner.piglin.cyan": "Ljósblátt Trýni",
  "block.minecraft.banner.piglin.gray": "Grátt Trýni",
  "block.minecraft.banner.piglin.green": "Grænt Trýni",
  "block.minecraft.banner.piglin.light_blue": "Ljósblátt Trýni",
  "block.minecraft.banner.piglin.light_gray": "Ljósgrátt Trýni",
  "block.minecraft.banner.piglin.lime": "Ljósgrænt Trýni",
  "block.minecraft.banner.piglin.magenta": "Vínrautt trýni",
  "block.minecraft.banner.piglin.orange": "Appelsínugult Trýni",
  "block.minecraft.banner.piglin.pink": "Bleikt Trýni",
  "block.minecraft.banner.piglin.purple": "Fjólublátt Trýni",
  "block.minecraft.banner.piglin.red": "Rautt Trýni",
  "block.minecraft.banner.piglin.white": "Hvítt Trýni",
  "block.minecraft.banner.piglin.yellow": "Gult Trýni",
  "block.minecraft.banner.rhombus.black": "Svartur tígull",
  "block.minecraft.banner.rhombus.blue": "Blár tígull",
  "block.minecraft.banner.rhombus.brown": "Brúnn tígull",
  "block.minecraft.banner.rhombus.cyan": "Blágrænn tígull",
  "block.minecraft.banner.rhombus.gray": "Grár tígull",
  "block.minecraft.banner.rhombus.green": "Grænn tígull",
  "block.minecraft.banner.rhombus.light_blue": "Ljósblár tígull",
  "block.minecraft.banner.rhombus.light_gray": "Ljósgrár tígull",
  "block.minecraft.banner.rhombus.lime": "Gulgrænn tígull",
  "block.minecraft.banner.rhombus.magenta": "Vínrauður tígull",
  "block.minecraft.banner.rhombus.orange": "Appelsínugulur tígull",
  "block.minecraft.banner.rhombus.pink": "Bleikur tígull",
  "block.minecraft.banner.rhombus.purple": "Fjólublár tígull",
  "block.minecraft.banner.rhombus.red": "Rauður tígull",
  "block.minecraft.banner.rhombus.white": "Hvítur tígull",
  "block.minecraft.banner.rhombus.yellow": "Gulur tígull",
  "block.minecraft.banner.skull.black": "Svart hauskúputákn",
  "block.minecraft.banner.skull.blue": "Blátt hauskúputákn",
  "block.minecraft.banner.skull.brown": "Brúnt hauskúputákn",
  "block.minecraft.banner.skull.cyan": "Heiðblátt hauskúputákn",
  "block.minecraft.banner.skull.gray": "Grátt hauskúputákn",
  "block.minecraft.banner.skull.green": "Grænt hauskúputákn",
  "block.minecraft.banner.skull.light_blue": "Ljósblátt hauskúputákn",
  "block.minecraft.banner.skull.light_gray": "Ljósgrátt hauskúputákn",
  "block.minecraft.banner.skull.lime": "Gulgrænt hauskúputákn",
  "block.minecraft.banner.skull.magenta": "Vínrautt hauskúputákn",
  "block.minecraft.banner.skull.orange": "Appelsínugult hauskúputákn",
  "block.minecraft.banner.skull.pink": "Bleikt hauskúputákn",
  "block.minecraft.banner.skull.purple": "Fjólublátt hauskúputákn",
  "block.minecraft.banner.skull.red": "Rautt hauskúputákn",
  "block.minecraft.banner.skull.white": "Hvítt hauskúputákn",
  "block.minecraft.banner.skull.yellow": "Gult hauskúputákn",
  "block.minecraft.banner.small_stripes.black": "Svört rönd",
  "block.minecraft.banner.small_stripes.blue": "Blá rönd",
  "block.minecraft.banner.small_stripes.brown": "Brún rönd",
  "block.minecraft.banner.small_stripes.cyan": "Heiðblá rönd",
  "block.minecraft.banner.small_stripes.gray": "Grá rönd",
  "block.minecraft.banner.small_stripes.green": "Græn rönd",
  "block.minecraft.banner.small_stripes.light_blue": "Ljósblá rönd",
  "block.minecraft.banner.small_stripes.light_gray": "Ljósgrá rönd",
  "block.minecraft.banner.small_stripes.lime": "Gulgræn rönd",
  "block.minecraft.banner.small_stripes.magenta": "Vínrauð rönd",
  "block.minecraft.banner.small_stripes.orange": "Appelsínugul rönd",
  "block.minecraft.banner.small_stripes.pink": "Bleik rönd",
  "block.minecraft.banner.small_stripes.purple": "Fjólublá rönd",
  "block.minecraft.banner.small_stripes.red": "Rauð rönd",
  "block.minecraft.banner.small_stripes.white": "Hvít rönd",
  "block.minecraft.banner.small_stripes.yellow": "Gul rönd",
  "block.minecraft.banner.square_bottom_left.black": "Svart niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.blue": "Blátt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.brown": "Brúnt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.cyan": "Heiðblátt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.gray": "Grátt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.green": "Grænt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljósblátt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljósgrátt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.lime": "Gulgrænt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.magenta": "Vínrautt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.orange": "Appelsínugult niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.pink": "Bleikt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.purple": "Fjólublátt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.red": "Rautt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.white": "Hvítt niðri til vinstri",
  "block.minecraft.banner.square_bottom_left.yellow": "Gult niðri til vinstri",
  "block.minecraft.banner.square_bottom_right.black": "Svart niðri til hægri",
  "block.minecraft.banner.square_bottom_right.blue": "Blátt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.brown": "Brúnt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.cyan": "Heiðblátt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.gray": "Grátt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.green": "Grænt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljósblátt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljósgrátt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.lime": "Gulgrænt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.magenta": "Vínrautt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.orange": "Appelsínugult niðri til hægri",
  "block.minecraft.banner.square_bottom_right.pink": "Bleikt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.purple": "Fjólublátt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.red": "Rautt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.white": "Hvítt niðri til hægri",
  "block.minecraft.banner.square_bottom_right.yellow": "Gult niðri til hægri",
  "block.minecraft.banner.square_top_left.black": "Svart uppi til vinstri",
  "block.minecraft.banner.square_top_left.blue": "Blátt uppi til vinstri",
  "block.minecraft.banner.square_top_left.brown": "Brúnt uppi til vinstri",
  "block.minecraft.banner.square_top_left.cyan": "Heiðblátt uppi til vinstri",
  "block.minecraft.banner.square_top_left.gray": "Grátt uppi til vinstri",
  "block.minecraft.banner.square_top_left.green": "Grænt uppi til vinstri",
  "block.minecraft.banner.square_top_left.light_blue": "Ljósblátt uppi til vinstri",
  "block.minecraft.banner.square_top_left.light_gray": "Ljósgrátt uppi til vinstri",
  "block.minecraft.banner.square_top_left.lime": "Gulgrænt uppi til vinstri",
  "block.minecraft.banner.square_top_left.magenta": "Vínrautt uppi til vinstri",
  "block.minecraft.banner.square_top_left.orange": "Appelsínugult uppi til vinstri",
  "block.minecraft.banner.square_top_left.pink": "Bleikt uppi til vinstri",
  "block.minecraft.banner.square_top_left.purple": "Fjólublátt uppi til vinstri",
  "block.minecraft.banner.square_top_left.red": "Rautt uppi til vinstri",
  "block.minecraft.banner.square_top_left.white": "Hvítt uppi til vinstri",
  "block.minecraft.banner.square_top_left.yellow": "Gult uppi til vinstri",
  "block.minecraft.banner.square_top_right.black": "Svart uppi til hægri",
  "block.minecraft.banner.square_top_right.blue": "Blátt uppi til hægri",
  "block.minecraft.banner.square_top_right.brown": "Brúnt uppi til hægri",
  "block.minecraft.banner.square_top_right.cyan": "Heiðblátt uppi til hægri",
  "block.minecraft.banner.square_top_right.gray": "Grátt uppi til hægri",
  "block.minecraft.banner.square_top_right.green": "Grænt uppi til hægri",
  "block.minecraft.banner.square_top_right.light_blue": "Ljósblátt uppi til hægri",
  "block.minecraft.banner.square_top_right.light_gray": "Ljósgrátt uppi til hægri",
  "block.minecraft.banner.square_top_right.lime": "Gulgrænt uppi til hægri",
  "block.minecraft.banner.square_top_right.magenta": "Vínrautt uppi til hægri",
  "block.minecraft.banner.square_top_right.orange": "Appelsínugult uppi til hægri",
  "block.minecraft.banner.square_top_right.pink": "Bleikt uppi til hægri",
  "block.minecraft.banner.square_top_right.purple": "Fjólublátt uppi til hægri",
  "block.minecraft.banner.square_top_right.red": "Rautt uppi til hægri",
  "block.minecraft.banner.square_top_right.white": "Hvítt uppi til hægri",
  "block.minecraft.banner.square_top_right.yellow": "Gult uppi til hægri",
  "block.minecraft.banner.straight_cross.black": "Svartur Kross",
  "block.minecraft.banner.straight_cross.blue": "Blár Kross",
  "block.minecraft.banner.straight_cross.brown": "Brúnn Kross",
  "block.minecraft.banner.straight_cross.cyan": "Blágrænn Kross",
  "block.minecraft.banner.straight_cross.gray": "Grár Kross",
  "block.minecraft.banner.straight_cross.green": "Grænn Kross",
  "block.minecraft.banner.straight_cross.light_blue": "Ljósblár Kross",
  "block.minecraft.banner.straight_cross.light_gray": "Ljósgrár Kross",
  "block.minecraft.banner.straight_cross.lime": "Ljósgrænn Kross",
  "block.minecraft.banner.straight_cross.magenta": "Vínrauður kross",
  "block.minecraft.banner.straight_cross.orange": "Appelsínugulur Kross",
  "block.minecraft.banner.straight_cross.pink": "Bleikur Kross",
  "block.minecraft.banner.straight_cross.purple": "Fjólublár Kross",
  "block.minecraft.banner.straight_cross.red": "Rauður Kross",
  "block.minecraft.banner.straight_cross.white": "Hvítur Kross",
  "block.minecraft.banner.straight_cross.yellow": "Gulur Kross",
  "block.minecraft.banner.stripe_bottom.black": "Svartur Grunnur",
  "block.minecraft.banner.stripe_bottom.blue": "Blár Grunnur",
  "block.minecraft.banner.stripe_bottom.brown": "Brúnn Grunnur",
  "block.minecraft.banner.stripe_bottom.cyan": "Blágrænn Grunnur",
  "block.minecraft.banner.stripe_bottom.gray": "Grár Grunnur",
  "block.minecraft.banner.stripe_bottom.green": "Grænn Grunnur",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljósblár Grunnur",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljósgrár Grunnur",
  "block.minecraft.banner.stripe_bottom.lime": "Gulgrænn Grunnur",
  "block.minecraft.banner.stripe_bottom.magenta": "Vínrauður grunnur",
  "block.minecraft.banner.stripe_bottom.orange": "Appelsínugulur Grunnur",
  "block.minecraft.banner.stripe_bottom.pink": "Bleikur Grunnur",
  "block.minecraft.banner.stripe_bottom.purple": "Fjólublár Grunnur",
  "block.minecraft.banner.stripe_bottom.red": "Rauður Grunnur",
  "block.minecraft.banner.stripe_bottom.white": "Hvítur Grunnur",
  "block.minecraft.banner.stripe_bottom.yellow": "Gulur Grunnur",
  "block.minecraft.banner.stripe_center.black": "Svart lóðrétt þverband",
  "block.minecraft.banner.stripe_center.blue": "Blátt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.brown": "Brúnt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.cyan": "Heiðblátt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.gray": "Grátt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.green": "Grænt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.light_blue": "Ljósblátt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.light_gray": "Ljósgrátt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.lime": "Gulgrænt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.magenta": "Vínrautt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.orange": "Appelsínugult lóðrétt þverband",
  "block.minecraft.banner.stripe_center.pink": "Bleikt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.purple": "Fjólublátt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.red": "Rautt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.white": "Hvítt lóðrétt þverband",
  "block.minecraft.banner.stripe_center.yellow": "Gult lóðrétt þverband",
  "block.minecraft.banner.stripe_downleft.black": "Svört öfug skárönd",
  "block.minecraft.banner.stripe_downleft.blue": "Blá öfug skárönd",
  "block.minecraft.banner.stripe_downleft.brown": "Brún öfug skárönd",
  "block.minecraft.banner.stripe_downleft.cyan": "Heiðblá öfug skárönd",
  "block.minecraft.banner.stripe_downleft.gray": "Grá öfug skárönd",
  "block.minecraft.banner.stripe_downleft.green": "Græn öfug skárönd",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljósblá öfug skárönd",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljósgrá öfug skárönd",
  "block.minecraft.banner.stripe_downleft.lime": "Gulgræn öfug skárönd",
  "block.minecraft.banner.stripe_downleft.magenta": "Vínrauð öfug skárönd",
  "block.minecraft.banner.stripe_downleft.orange": "Appelsínugul öfug skárönd",
  "block.minecraft.banner.stripe_downleft.pink": "Bleik öfug skárönd",
  "block.minecraft.banner.stripe_downleft.purple": "Fjólublá öfug skárönd",
  "block.minecraft.banner.stripe_downleft.red": "Rauð öfug skárönd",
  "block.minecraft.banner.stripe_downleft.white": "Hvít öfug skárönd",
  "block.minecraft.banner.stripe_downleft.yellow": "Gul öfug skárönd",
  "block.minecraft.banner.stripe_downright.black": "Svört skárönd",
  "block.minecraft.banner.stripe_downright.blue": "Blá skárönd",
  "block.minecraft.banner.stripe_downright.brown": "Brún skárönd",
  "block.minecraft.banner.stripe_downright.cyan": "Heiðblá skárönd",
  "block.minecraft.banner.stripe_downright.gray": "Grá skárönd",
  "block.minecraft.banner.stripe_downright.green": "Græn skárönd",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljósblá skárönd",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljósgrá skárönd",
  "block.minecraft.banner.stripe_downright.lime": "Gulgræn skárönd",
  "block.minecraft.banner.stripe_downright.magenta": "Vínrauð skárönd",
  "block.minecraft.banner.stripe_downright.orange": "Appelsínugul skárönd",
  "block.minecraft.banner.stripe_downright.pink": "Bleik skárönd",
  "block.minecraft.banner.stripe_downright.purple": "Fjólublá skárönd",
  "block.minecraft.banner.stripe_downright.red": "Rauð skárönd",
  "block.minecraft.banner.stripe_downright.white": "Hvít skárönd",
  "block.minecraft.banner.stripe_downright.yellow": "Gul skárönd",
  "block.minecraft.banner.stripe_left.black": "Svart vinstra megin",
  "block.minecraft.banner.stripe_left.blue": "Blátt vinstra megin",
  "block.minecraft.banner.stripe_left.brown": "Brúnt vinstra megin",
  "block.minecraft.banner.stripe_left.cyan": "Heiðblátt vinstra megin",
  "block.minecraft.banner.stripe_left.gray": "Grátt vinstra megin",
  "block.minecraft.banner.stripe_left.green": "Grænt vinstra megin",
  "block.minecraft.banner.stripe_left.light_blue": "Ljósblátt vinstra megin",
  "block.minecraft.banner.stripe_left.light_gray": "Ljósgrátt vinstra megin",
  "block.minecraft.banner.stripe_left.lime": "Gulgrænt vinstra megin",
  "block.minecraft.banner.stripe_left.magenta": "Vínrautt þverband vinstra megin",
  "block.minecraft.banner.stripe_left.orange": "Appelsínugult vinstra megin",
  "block.minecraft.banner.stripe_left.pink": "Bleikt vinstra megin",
  "block.minecraft.banner.stripe_left.purple": "Fjólblátt vinstra megin",
  "block.minecraft.banner.stripe_left.red": "Rautt vinstra megin",
  "block.minecraft.banner.stripe_left.white": "Hvítt vinstra megin",
  "block.minecraft.banner.stripe_left.yellow": "Gult vinstra megin",
  "block.minecraft.banner.stripe_middle.black": "Svört lárétt rönd",
  "block.minecraft.banner.stripe_middle.blue": "Blá lárétt rönd",
  "block.minecraft.banner.stripe_middle.brown": "Brún lárétt rönd",
  "block.minecraft.banner.stripe_middle.cyan": "Heiðblá lárétt rönd",
  "block.minecraft.banner.stripe_middle.gray": "Grá lárétt rönd",
  "block.minecraft.banner.stripe_middle.green": "Græn lárétt rönd",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljósblá lárétt rönd",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljósgrá lárétt rönd",
  "block.minecraft.banner.stripe_middle.lime": "Gulgræn lárétt rönd",
  "block.minecraft.banner.stripe_middle.magenta": "Vínrauð lárétt rönd",
  "block.minecraft.banner.stripe_middle.orange": "Appelsínugul lárétt rönd",
  "block.minecraft.banner.stripe_middle.pink": "Bleik lárétt rönd",
  "block.minecraft.banner.stripe_middle.purple": "Fjólublá lárétt rönd",
  "block.minecraft.banner.stripe_middle.red": "Rauð lárétt rönd",
  "block.minecraft.banner.stripe_middle.white": "Hvít lárétt rönd",
  "block.minecraft.banner.stripe_middle.yellow": "Gul lárétt rönd",
  "block.minecraft.banner.stripe_right.black": "Svart hægra megin",
  "block.minecraft.banner.stripe_right.blue": "Blátt hægra megin",
  "block.minecraft.banner.stripe_right.brown": "Brúnt hægra megin",
  "block.minecraft.banner.stripe_right.cyan": "Heiðblátt hægra megin",
  "block.minecraft.banner.stripe_right.gray": "Grátt hægra megin",
  "block.minecraft.banner.stripe_right.green": "Grænt hægra megin",
  "block.minecraft.banner.stripe_right.light_blue": "Ljósblátt hægra megin",
  "block.minecraft.banner.stripe_right.light_gray": "Ljósgrátt hægra megin",
  "block.minecraft.banner.stripe_right.lime": "Gulgrænt hægra megin",
  "block.minecraft.banner.stripe_right.magenta": "Vínrautt þverband hægra megin",
  "block.minecraft.banner.stripe_right.orange": "Appelsínugult hægra megin",
  "block.minecraft.banner.stripe_right.pink": "Bleikt hægra megin",
  "block.minecraft.banner.stripe_right.purple": "Fjólublátt hægra megin",
  "block.minecraft.banner.stripe_right.red": "Rautt hægra megin",
  "block.minecraft.banner.stripe_right.white": "Hvítt hægra megin",
  "block.minecraft.banner.stripe_right.yellow": "Gult hægra megin",
  "block.minecraft.banner.stripe_top.black": "Svartur toppkantur",
  "block.minecraft.banner.stripe_top.blue": "Blár toppkantur",
  "block.minecraft.banner.stripe_top.brown": "Brúnn toppkantur",
  "block.minecraft.banner.stripe_top.cyan": "Heiðblár toppkantur",
  "block.minecraft.banner.stripe_top.gray": "Grár toppkantur",
  "block.minecraft.banner.stripe_top.green": "Grænn toppkantur",
  "block.minecraft.banner.stripe_top.light_blue": "Ljósblár toppkantur",
  "block.minecraft.banner.stripe_top.light_gray": "Ljósgrár toppkantur",
  "block.minecraft.banner.stripe_top.lime": "Ljósgrænn toppkantur",
  "block.minecraft.banner.stripe_top.magenta": "Vínrauður toppkantur",
  "block.minecraft.banner.stripe_top.orange": "Appelsínugulur toppkantur",
  "block.minecraft.banner.stripe_top.pink": "Bleikur toppkantur",
  "block.minecraft.banner.stripe_top.purple": "Fjólublár toppkantur",
  "block.minecraft.banner.stripe_top.red": "Rauður toppkantur",
  "block.minecraft.banner.stripe_top.white": "Hvítur toppkantur",
  "block.minecraft.banner.stripe_top.yellow": "Gulur toppkantur",
  "block.minecraft.banner.triangle_bottom.black": "Svartur þríhyrningur",
  "block.minecraft.banner.triangle_bottom.blue": "Blár þríhyrningur",
  "block.minecraft.banner.triangle_bottom.brown": "Brúnn þríhyrningur",
  "block.minecraft.banner.triangle_bottom.cyan": "Blágrænn þríhyrningur",
  "block.minecraft.banner.triangle_bottom.gray": "Grár þríhyrningur",
  "block.minecraft.banner.triangle_bottom.green": "Grænn þríhyrningur",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljósblár þríhyrningur",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljósgrár þríhyrningur",
  "block.minecraft.banner.triangle_bottom.lime": "Ljósgrænn þríhyrningur",
  "block.minecraft.banner.triangle_bottom.magenta": "Vínrauður fleygur",
  "block.minecraft.banner.triangle_bottom.orange": "Appelsínugulur þríhyrningur",
  "block.minecraft.banner.triangle_bottom.pink": "Bleikur þríhyrningur",
  "block.minecraft.banner.triangle_bottom.purple": "Fjólublár þríhyrningur",
  "block.minecraft.banner.triangle_bottom.red": "Rauður þríhyrningur",
  "block.minecraft.banner.triangle_bottom.white": "Hvítur þríhyrningur",
  "block.minecraft.banner.triangle_bottom.yellow": "Gulur þríhyrningur",
  "block.minecraft.banner.triangle_top.black": "Svartur öfugur fleygur",
  "block.minecraft.banner.triangle_top.blue": "Blár öfugur fleygur",
  "block.minecraft.banner.triangle_top.brown": "Brúnn öfugur fleygur",
  "block.minecraft.banner.triangle_top.cyan": "syan öfugur klóber",
  "block.minecraft.banner.triangle_top.gray": "Grár öfugur klóber",
  "block.minecraft.banner.triangle_top.green": "Grænn öfugur fleygur",
  "block.minecraft.banner.triangle_top.light_blue": "Ljósblátt hvolfi Chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Ljósgrárr öfugur klóber",
  "block.minecraft.banner.triangle_top.lime": "kalki hvolfdi",
  "block.minecraft.banner.triangle_top.magenta": "Vínrauður öfugur fleygur",
  "block.minecraft.banner.triangle_top.orange": "Orange hvolfi Chevron",
  "block.minecraft.banner.triangle_top.pink": "Bleikur öfugur klóber",
  "block.minecraft.banner.triangle_top.purple": "Fjólublár öfugur fleygur",
  "block.minecraft.banner.triangle_top.red": "Rauður öfugur fleygur",
  "block.minecraft.banner.triangle_top.white": "Hvítur hvolfi Chevron",
  "block.minecraft.banner.triangle_top.yellow": "Gulur öfugur fleygur",
  "block.minecraft.banner.triangles_bottom.black": "Svartur Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.blue": "Blár Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.brown": "Brúnn Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.cyan": "Blágrænn Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.gray": "Grár Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.green": "Grænn Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljósblár Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljósgrár Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.lime": "Kalkgrind Inndráttur",
  "block.minecraft.banner.triangles_bottom.magenta": "Vínrauður inndreginn grunnur",
  "block.minecraft.banner.triangles_bottom.orange": "Appelsínugulur Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.pink": "Bleikur Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.purple": "Fjólublár Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.red": "Rauður Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.white": "Hvítur Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_bottom.yellow": "Gulur Vogskorinn Grunnur",
  "block.minecraft.banner.triangles_top.black": "Svartur Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.blue": "Blár Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.brown": "Brúnn Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.cyan": "Blárgrænn Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.gray": "Grár Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.green": "Grænn Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.light_blue": "Ljósblár Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.light_gray": "Ljósgrár Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.lime": "Límóna Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.magenta": "Vínrauður inndreginn toppkantur",
  "block.minecraft.banner.triangles_top.orange": "Appelsínugulur Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.pink": "Bleikur Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.purple": "Fjólublár Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.red": "Rauður Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.white": "Hvítur Vogskorinn Höfðingi",
  "block.minecraft.banner.triangles_top.yellow": "Gulur Vogskorinn Höfðingi",
  "block.minecraft.barrel": "Tunna",
  "block.minecraft.barrier": "Hindrun",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Leiðarljós",
  "block.minecraft.beacon.primary": "Aðalkraftur",
  "block.minecraft.beacon.secondary": "Aukakraftur",
  "block.minecraft.bed.no_sleep": "Þú getur aðeins sofið á nóttinni eða í þrumuveðrum",
  "block.minecraft.bed.not_safe": "Þú getur ekki hvílst núna; það eru skrímsli í nágrenninu",
  "block.minecraft.bed.obstructed": "Þetta rúm er hindrað",
  "block.minecraft.bed.occupied": "Þetta rúm er upptekið",
  "block.minecraft.bed.too_far_away": "Þú getur ekki hvílt þig núna; rúmið er of langt í burtu",
  "block.minecraft.bedrock": "Berggrunnur",
  "block.minecraft.bee_nest": "Býflugnahreiður",
  "block.minecraft.beehive": "Býflugnabú",
  "block.minecraft.beetroots": "Rauðrófur",
  "block.minecraft.bell": "Bjalla",
  "block.minecraft.big_dripleaf": "Stórt Hallalauf",
  "block.minecraft.big_dripleaf_stem": "Stór Hallalaufs stofn",
  "block.minecraft.birch_button": "Birkihnappur",
  "block.minecraft.birch_door": "Birkihurð",
  "block.minecraft.birch_fence": "Birkigirðing",
  "block.minecraft.birch_fence_gate": "Birkihlið",
  "block.minecraft.birch_hanging_sign": "Hangandi birkiskilti",
  "block.minecraft.birch_leaves": "Birkilauf",
  "block.minecraft.birch_log": "Birkidrumbur",
  "block.minecraft.birch_planks": "Birkiplankar",
  "block.minecraft.birch_pressure_plate": "Þrýstihella úr birki",
  "block.minecraft.birch_sapling": "Birkigræðlingur",
  "block.minecraft.birch_shelf": "Birkihilla",
  "block.minecraft.birch_sign": "Birkiskilti",
  "block.minecraft.birch_slab": "Birkihella",
  "block.minecraft.birch_stairs": "Birkitröppur",
  "block.minecraft.birch_trapdoor": "Birkihleri",
  "block.minecraft.birch_wall_hanging_sign": "Vegghangandi birkiskilti",
  "block.minecraft.birch_wall_sign": "Birkiskilti á vegg",
  "block.minecraft.birch_wood": "Birkiviður",
  "block.minecraft.black_banner": "Svartur fáni",
  "block.minecraft.black_bed": "Svart Rúm",
  "block.minecraft.black_candle": "Svart kerti",
  "block.minecraft.black_candle_cake": "Kaka með svörtu kerti",
  "block.minecraft.black_carpet": "Svart gólfteppi",
  "block.minecraft.black_concrete": "Svört steinsteypa",
  "block.minecraft.black_concrete_powder": "Svart sement",
  "block.minecraft.black_glazed_terracotta": "Svartur glerjaður brenndur leir",
  "block.minecraft.black_shulker_box": "Svart hylki skálks",
  "block.minecraft.black_stained_glass": "Svart Litað Gler",
  "block.minecraft.black_stained_glass_pane": "Svört lituð rúða",
  "block.minecraft.black_terracotta": "Svart keramik",
  "block.minecraft.black_wool": "Svört ull",
  "block.minecraft.blackstone": "Svartgrýti",
  "block.minecraft.blackstone_slab": "Svartgrýtishella",
  "block.minecraft.blackstone_stairs": "Svartgrýtiströppur",
  "block.minecraft.blackstone_wall": "Svartgrýtismúr",
  "block.minecraft.blast_furnace": "Bræðsluofn",
  "block.minecraft.blue_banner": "Blár fáni",
  "block.minecraft.blue_bed": "Blátt Rúm",
  "block.minecraft.blue_candle": "Blátt kerti",
  "block.minecraft.blue_candle_cake": "Kaka með bláu kerti",
  "block.minecraft.blue_carpet": "Blátt gólfteppi",
  "block.minecraft.blue_concrete": "Blá steinsteypa",
  "block.minecraft.blue_concrete_powder": "Blátt sement",
  "block.minecraft.blue_glazed_terracotta": "Blár glerjaður brenndur leir",
  "block.minecraft.blue_ice": "Bláís",
  "block.minecraft.blue_orchid": "Blátt brönugras",
  "block.minecraft.blue_shulker_box": "Blátt hylki skálks",
  "block.minecraft.blue_stained_glass": "Blálitað Gler",
  "block.minecraft.blue_stained_glass_pane": "Lituð blá rúða",
  "block.minecraft.blue_terracotta": "Blátt keramik",
  "block.minecraft.blue_wool": "Blá ull",
  "block.minecraft.bone_block": "Beinakubbur",
  "block.minecraft.bookshelf": "Bókahilla",
  "block.minecraft.brain_coral": "Heilakórall",
  "block.minecraft.brain_coral_block": "Heilakóralskubbur",
  "block.minecraft.brain_coral_fan": "Heilakóralsvængur",
  "block.minecraft.brain_coral_wall_fan": "Heilakóralsveggvængur",
  "block.minecraft.brewing_stand": "Bruggstöð",
  "block.minecraft.brick_slab": "Múrhella",
  "block.minecraft.brick_stairs": "Múrsteinströppur",
  "block.minecraft.brick_wall": "Múrsteinsveggur",
  "block.minecraft.bricks": "Múrsteinar",
  "block.minecraft.brown_banner": "Brúnn fáni",
  "block.minecraft.brown_bed": "Brúnt rúm",
  "block.minecraft.brown_candle": "Brúnt kerti",
  "block.minecraft.brown_candle_cake": "Kaka með brúnu kerti",
  "block.minecraft.brown_carpet": "Brúnt gólfteppi",
  "block.minecraft.brown_concrete": "Brún steinsteypa",
  "block.minecraft.brown_concrete_powder": "Brúnt sement",
  "block.minecraft.brown_glazed_terracotta": "Brúnn glerjaður brenndur leir",
  "block.minecraft.brown_mushroom": "Brúnn sveppakubbur",
  "block.minecraft.brown_mushroom_block": "Brúnn sveppakubbur",
  "block.minecraft.brown_shulker_box": "Brúnt hylki skálks",
  "block.minecraft.brown_stained_glass": "Brúnlitt Gler",
  "block.minecraft.brown_stained_glass_pane": "Lituð brún rúða",
  "block.minecraft.brown_terracotta": "Brúnt keramik",
  "block.minecraft.brown_wool": "Brún ull",
  "block.minecraft.bubble_column": "Loftbólusúla",
  "block.minecraft.bubble_coral": "Kúlukórall",
  "block.minecraft.bubble_coral_block": "Kúlukóralskubbur",
  "block.minecraft.bubble_coral_fan": "Kúlukóralsvængur",
  "block.minecraft.bubble_coral_wall_fan": "Kúlukóralsveggvængur",
  "block.minecraft.budding_amethyst": "Brumandi blákvars",
  "block.minecraft.bush": "Runni",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblóm",
  "block.minecraft.cake": "Kaka",
  "block.minecraft.calcite": "Kalsít",
  "block.minecraft.calibrated_sculk_sensor": "Kvarðaður skelksnemi",
  "block.minecraft.campfire": "Varðeldur",
  "block.minecraft.candle": "Kerti",
  "block.minecraft.candle_cake": "Kaka með kertum",
  "block.minecraft.carrots": "Gulrætur",
  "block.minecraft.cartography_table": "Kortaborð",
  "block.minecraft.carved_pumpkin": "Útskorið grasker",
  "block.minecraft.cauldron": "Seiðpottur",
  "block.minecraft.cave_air": "Hellisloft",
  "block.minecraft.cave_vines": "Hellavínviður",
  "block.minecraft.cave_vines_plant": "Hellavínviðsplanta",
  "block.minecraft.chain": "Járnkeðja",
  "block.minecraft.chain_command_block": "Raðforritunarkubbur",
  "block.minecraft.cherry_button": "Kirsuberjahnappur",
  "block.minecraft.cherry_door": "Kirsuberjahurð",
  "block.minecraft.cherry_fence": "Kirsuberjagirðing",
  "block.minecraft.cherry_fence_gate": "Kirsuberjahlið",
  "block.minecraft.cherry_hanging_sign": "Hangandi kirsuberjaskilti",
  "block.minecraft.cherry_leaves": "Kirsuberjalauf",
  "block.minecraft.cherry_log": "Kirsuberjadrumbur",
  "block.minecraft.cherry_planks": "Kirsuberjaplankar",
  "block.minecraft.cherry_pressure_plate": "Kirsuberjaþrýstihella",
  "block.minecraft.cherry_sapling": "Kirsuberjagræðlingur",
  "block.minecraft.cherry_shelf": "Kirsuberjahilla",
  "block.minecraft.cherry_sign": "Kirsuberjaskilti",
  "block.minecraft.cherry_slab": "Kirsuberjahella",
  "block.minecraft.cherry_stairs": "Kirsuberjatröppur",
  "block.minecraft.cherry_trapdoor": "Kirsuberjahleri",
  "block.minecraft.cherry_wall_hanging_sign": "Vegghangandi kirsuberjaskilti",
  "block.minecraft.cherry_wall_sign": "Kirsuberjaveggskilti",
  "block.minecraft.cherry_wood": "Kirsuberjaviður",
  "block.minecraft.chest": "Kista",
  "block.minecraft.chipped_anvil": "Skaðaður steðji",
  "block.minecraft.chiseled_bookshelf": "Meitluð bókahilla",
  "block.minecraft.chiseled_copper": "Meitlaður kopar",
  "block.minecraft.chiseled_deepslate": "Meitlað djúpberg",
  "block.minecraft.chiseled_nether_bricks": "Tilhöggnir heljarmúrsteinar",
  "block.minecraft.chiseled_polished_blackstone": "Tilhöggvið slípað svartgrýti",
  "block.minecraft.chiseled_quartz_block": "Tilhöggvinn kvarskubbur",
  "block.minecraft.chiseled_red_sandstone": "Meitlaður rauður sandsteinn",
  "block.minecraft.chiseled_resin_bricks": "Meitlaðir kvoðusteinar",
  "block.minecraft.chiseled_sandstone": "Útskorinn sandsteinn",
  "block.minecraft.chiseled_stone_bricks": "Útskorinn steinmúr",
  "block.minecraft.chiseled_tuff": "Meitlað móberg",
  "block.minecraft.chiseled_tuff_bricks": "Meitlaðir móbergssteinar",
  "block.minecraft.chorus_flower": "Kórblóm",
  "block.minecraft.chorus_plant": "Kórplanta",
  "block.minecraft.clay": "Leir",
  "block.minecraft.closed_eyeblossom": "Lokað augnablóm",
  "block.minecraft.coal_block": "Kolakubbur",
  "block.minecraft.coal_ore": "Kolagrýti",
  "block.minecraft.coarse_dirt": "Gróf mold",
  "block.minecraft.cobbled_deepslate": "Djúpgrýti",
  "block.minecraft.cobbled_deepslate_slab": "Djúpgrýtishellur",
  "block.minecraft.cobbled_deepslate_stairs": "Djúpgrýtiströppur",
  "block.minecraft.cobbled_deepslate_wall": "Djúpgrýtisveggur",
  "block.minecraft.cobblestone": "Grjót",
  "block.minecraft.cobblestone_slab": "Grjóthella",
  "block.minecraft.cobblestone_stairs": "Steintröppur",
  "block.minecraft.cobblestone_wall": "Steinveggur",
  "block.minecraft.cobweb": "Köngulóarvefur",
  "block.minecraft.cocoa": "Kakó",
  "block.minecraft.command_block": "Forritunarkubbur",
  "block.minecraft.comparator": "Samanburðarrofi",
  "block.minecraft.composter": "Moltukassi",
  "block.minecraft.conduit": "Flæðari",
  "block.minecraft.copper_bars": "Koparrimlar",
  "block.minecraft.copper_block": "Koparkubbur",
  "block.minecraft.copper_bulb": "Koparpera",
  "block.minecraft.copper_chain": "Koparkeðja",
  "block.minecraft.copper_chest": "Koparkista",
  "block.minecraft.copper_door": "Koparhurð",
  "block.minecraft.copper_golem_statue": "Koparþjarkar stytta",
  "block.minecraft.copper_grate": "Kopargrind",
  "block.minecraft.copper_lantern": "Koparlukt",
  "block.minecraft.copper_ore": "Kopargrýti",
  "block.minecraft.copper_torch": "Koparkyndill",
  "block.minecraft.copper_trapdoor": "Koparhleri",
  "block.minecraft.copper_wall_torch": "Koparkyndill á vegg",
  "block.minecraft.cornflower": "Garðakornblóm",
  "block.minecraft.cracked_deepslate_bricks": "Brotinn djúpbergsmúr",
  "block.minecraft.cracked_deepslate_tiles": "Brotnar djúpbergshellur",
  "block.minecraft.cracked_nether_bricks": "Brotnir heljarmúrsteinar",
  "block.minecraft.cracked_polished_blackstone_bricks": "Brotnir slípaðir svartgrýtismúrsteinar",
  "block.minecraft.cracked_stone_bricks": "Brotin steinhleðsla",
  "block.minecraft.crafter": "Smiðja",
  "block.minecraft.crafting_table": "Vinnubekkur",
  "block.minecraft.creaking_heart": "Brakandahjarta",
  "block.minecraft.creeper_head": "Laumupúkahöfuð",
  "block.minecraft.creeper_wall_head": "Laumupúkahöfuð á vegg",
  "block.minecraft.crimson_button": "Hárauður hnappur",
  "block.minecraft.crimson_door": "Hárauð hurð",
  "block.minecraft.crimson_fence": "Hárauð girðing",
  "block.minecraft.crimson_fence_gate": "Hárautt hlið",
  "block.minecraft.crimson_fungus": "Hárauður sveppur",
  "block.minecraft.crimson_hanging_sign": "Hangandi hárautt skilti",
  "block.minecraft.crimson_hyphae": "Hárauðir sveppaþræðir",
  "block.minecraft.crimson_nylium": "Hárautt heljarmygli",
  "block.minecraft.crimson_planks": "Hárauðir plankar",
  "block.minecraft.crimson_pressure_plate": "Hárauð þrýstihella",
  "block.minecraft.crimson_roots": "Hárautt heljargras",
  "block.minecraft.crimson_shelf": "Hárauðirhilla",
  "block.minecraft.crimson_sign": "Hárautt skilti",
  "block.minecraft.crimson_slab": "Hárauð hella",
  "block.minecraft.crimson_stairs": "Hárauðar tröppur",
  "block.minecraft.crimson_stem": "Hárauður stilkur",
  "block.minecraft.crimson_trapdoor": "Hárauð lúga",
  "block.minecraft.crimson_wall_hanging_sign": "Vegghangandi hárautt skilti",
  "block.minecraft.crimson_wall_sign": "Hárautt Veggskilti",
  "block.minecraft.crying_obsidian": "Grátandi hrafntinna",
  "block.minecraft.cut_copper": "Skorinn kopar",
  "block.minecraft.cut_copper_slab": "Skorin koparhella",
  "block.minecraft.cut_copper_stairs": "Skornar kopartröppur",
  "block.minecraft.cut_red_sandstone": "Skorinn rauður sandsteinn",
  "block.minecraft.cut_red_sandstone_slab": "Skorin rauð sandsteinshella",
  "block.minecraft.cut_sandstone": "Skorinn sandsteinn",
  "block.minecraft.cut_sandstone_slab": "Skorin sandsteinshella",
  "block.minecraft.cyan_banner": "Heiðblár fáni",
  "block.minecraft.cyan_bed": "Heiðblátt rúm",
  "block.minecraft.cyan_candle": "Blágrænt kerti",
  "block.minecraft.cyan_candle_cake": "Kaka með blágrænu kerti",
  "block.minecraft.cyan_carpet": "Heiðblátt gólfteppi",
  "block.minecraft.cyan_concrete": "Blágræn steinsteypa",
  "block.minecraft.cyan_concrete_powder": "Blágrænt sement",
  "block.minecraft.cyan_glazed_terracotta": "Blágrænn glerjaður brenndur leir",
  "block.minecraft.cyan_shulker_box": "Blágrænt hylki skálks",
  "block.minecraft.cyan_stained_glass": "Heiðblátt Gler",
  "block.minecraft.cyan_stained_glass_pane": "Heiðblá rúða",
  "block.minecraft.cyan_terracotta": "Heiðblá keramik",
  "block.minecraft.cyan_wool": "Heiðblá ull",
  "block.minecraft.damaged_anvil": "Skemmdur steðji",
  "block.minecraft.dandelion": "Túnfífill",
  "block.minecraft.dark_oak_button": "Dökkur eikarhnappur",
  "block.minecraft.dark_oak_door": "Dökkeikarhurð",
  "block.minecraft.dark_oak_fence": "Dökkeikargirðing",
  "block.minecraft.dark_oak_fence_gate": "Dökkeikarhlið",
  "block.minecraft.dark_oak_hanging_sign": "Hangandi dökkt eikarskilti",
  "block.minecraft.dark_oak_leaves": "Dökkeikarlauf",
  "block.minecraft.dark_oak_log": "Dökkeikardrumbur",
  "block.minecraft.dark_oak_planks": "Dökkeikarplankar",
  "block.minecraft.dark_oak_pressure_plate": "Þrýstihella úr dökkeik",
  "block.minecraft.dark_oak_sapling": "Dökkeikargræðlingur",
  "block.minecraft.dark_oak_shelf": "Dökkeikarhilla",
  "block.minecraft.dark_oak_sign": "Dökkt eikarskilti",
  "block.minecraft.dark_oak_slab": "Dökkeikarhella",
  "block.minecraft.dark_oak_stairs": "Dökkeikartröppur",
  "block.minecraft.dark_oak_trapdoor": "Dökkeikarhleri",
  "block.minecraft.dark_oak_wall_hanging_sign": "Vegghangandi dökkt eikarskilti",
  "block.minecraft.dark_oak_wall_sign": "Dökkt eikarskilti á vegg",
  "block.minecraft.dark_oak_wood": "Dökkeikarviður",
  "block.minecraft.dark_prismarine": "Dökkur hafsteinn",
  "block.minecraft.dark_prismarine_slab": "Dökk Hafsteinshella",
  "block.minecraft.dark_prismarine_stairs": "Dökkar hafsteinströppur",
  "block.minecraft.daylight_detector": "Ljósnemi",
  "block.minecraft.dead_brain_coral": "Dauður heilakórall",
  "block.minecraft.dead_brain_coral_block": "Dauður heilakóralskubbur",
  "block.minecraft.dead_brain_coral_fan": "Dauður heilakóralsvængur",
  "block.minecraft.dead_brain_coral_wall_fan": "Dauður Heilakóralsveggvængur",
  "block.minecraft.dead_bubble_coral": "Dauður kúlukórall",
  "block.minecraft.dead_bubble_coral_block": "Dauður kúlukóralskubbur",
  "block.minecraft.dead_bubble_coral_fan": "Dauður kúlukóralsvængur",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dauður Kúlukóralsveggvængur",
  "block.minecraft.dead_bush": "Dauður runni",
  "block.minecraft.dead_fire_coral": "Dauður funakórall",
  "block.minecraft.dead_fire_coral_block": "Dauður funakóralskubbur",
  "block.minecraft.dead_fire_coral_fan": "Dauður funakóralsvængur",
  "block.minecraft.dead_fire_coral_wall_fan": "Dauður Funakóralsveggvængur",
  "block.minecraft.dead_horn_coral": "Dauður hornakórall",
  "block.minecraft.dead_horn_coral_block": "Dauður hornkóralskubbur",
  "block.minecraft.dead_horn_coral_fan": "Dauður hornakóralsvængur",
  "block.minecraft.dead_horn_coral_wall_fan": "Dauður Hornakóralsveggvængur",
  "block.minecraft.dead_tube_coral": "Dauður pípukórall",
  "block.minecraft.dead_tube_coral_block": "Dauður pípukóralskubbur",
  "block.minecraft.dead_tube_coral_fan": "Dauður pípukóralsvængur",
  "block.minecraft.dead_tube_coral_wall_fan": "Dauður Pípukóralsveggvængur",
  "block.minecraft.decorated_pot": "Skreyttur pottur",
  "block.minecraft.deepslate": "Djúpberg",
  "block.minecraft.deepslate_brick_slab": "Djúpbergsmúrhella",
  "block.minecraft.deepslate_brick_stairs": "Djúpbergsmúrtröppur",
  "block.minecraft.deepslate_brick_wall": "Djúpbergsmúrveggur",
  "block.minecraft.deepslate_bricks": "Djúpbergsmúr",
  "block.minecraft.deepslate_coal_ore": "Djúpsteypt kolgrýti",
  "block.minecraft.deepslate_copper_ore": "Djúpsteypt kopargrýti",
  "block.minecraft.deepslate_diamond_ore": "Djúpsteypt demantsgrýti",
  "block.minecraft.deepslate_emerald_ore": "Djúpsteypt smaragðsgrýti",
  "block.minecraft.deepslate_gold_ore": "Djúpsteypt gullgrýti",
  "block.minecraft.deepslate_iron_ore": "Djúpsteypt járngrýti",
  "block.minecraft.deepslate_lapis_ore": "Djúpsteypt asúrgrýti",
  "block.minecraft.deepslate_redstone_ore": "Djúpsteypt rauðgrýti",
  "block.minecraft.deepslate_tile_slab": "Djúpbergsflísahella",
  "block.minecraft.deepslate_tile_stairs": "Djúpbergsflísatröppur",
  "block.minecraft.deepslate_tile_wall": "Djúpbergsflísaveggur",
  "block.minecraft.deepslate_tiles": "Djúpbergsflísar",
  "block.minecraft.detector_rail": "Skynjunarteinn",
  "block.minecraft.diamond_block": "Demantskubbur",
  "block.minecraft.diamond_ore": "Demantsgrýti",
  "block.minecraft.diorite": "Díórít",
  "block.minecraft.diorite_slab": "Díóríthella",
  "block.minecraft.diorite_stairs": "Díóríttröppur",
  "block.minecraft.diorite_wall": "Díórítveggur",
  "block.minecraft.dirt": "Mold",
  "block.minecraft.dirt_path": "Moldarstígur",
  "block.minecraft.dispenser": "Skammtari",
  "block.minecraft.dragon_egg": "Drekaegg",
  "block.minecraft.dragon_head": "Drekahöfuð",
  "block.minecraft.dragon_wall_head": "Drekahaus á vegg",
  "block.minecraft.dried_ghast": "Þurrvomur",
  "block.minecraft.dried_kelp_block": "Þurrkaður þarakubbur",
  "block.minecraft.dripstone_block": "Dropasteinskubbur",
  "block.minecraft.dropper": "Sleppir",
  "block.minecraft.emerald_block": "Smaragðskubbur",
  "block.minecraft.emerald_ore": "Smaragðsgrýti",
  "block.minecraft.enchanting_table": "Galdraborð",
  "block.minecraft.end_gateway": "Endagátt",
  "block.minecraft.end_portal": "Endagátt",
  "block.minecraft.end_portal_frame": "Endahliðsrammi",
  "block.minecraft.end_rod": "Endastaur",
  "block.minecraft.end_stone": "Endasteinn",
  "block.minecraft.end_stone_brick_slab": "Endasteinshella",
  "block.minecraft.end_stone_brick_stairs": "Endasteinströppur",
  "block.minecraft.end_stone_brick_wall": "Endasteinsveggur",
  "block.minecraft.end_stone_bricks": "Endasteinsmúr",
  "block.minecraft.ender_chest": "Endakista",
  "block.minecraft.exposed_chiseled_copper": "Óvarinn meitlaður kopar",
  "block.minecraft.exposed_copper": "Óvarinn kopar",
  "block.minecraft.exposed_copper_bars": "Óvarnir koparrimlar",
  "block.minecraft.exposed_copper_bulb": "Óvarin koparpera",
  "block.minecraft.exposed_copper_chain": "Óvarin koparkeðja",
  "block.minecraft.exposed_copper_chest": "Óvarin koparkista",
  "block.minecraft.exposed_copper_door": "Óvarin koparhurð",
  "block.minecraft.exposed_copper_golem_statue": "Óvarin koparþjarkar stytta",
  "block.minecraft.exposed_copper_grate": "Óvarið kopargrind",
  "block.minecraft.exposed_copper_lantern": "Óvarin koparlukt",
  "block.minecraft.exposed_copper_trapdoor": "Óvarinn koparhleri",
  "block.minecraft.exposed_cut_copper": "Óvarinn skorinn kopar",
  "block.minecraft.exposed_cut_copper_slab": "Óvarin skorin koparhella",
  "block.minecraft.exposed_cut_copper_stairs": "Óvarnar skornar kopartröppur",
  "block.minecraft.exposed_lightning_rod": "Óvarinn eldingavari",
  "block.minecraft.farmland": "Ræktunarland",
  "block.minecraft.fern": "Burkni",
  "block.minecraft.fire": "Eldur",
  "block.minecraft.fire_coral": "Funakórall",
  "block.minecraft.fire_coral_block": "Funakóralskubbur",
  "block.minecraft.fire_coral_fan": "Funakóralsvængur",
  "block.minecraft.fire_coral_wall_fan": "Funakóralsveggvængur",
  "block.minecraft.firefly_bush": "Blysbjöllurunni",
  "block.minecraft.fletching_table": "Fjöðrunarbekkur",
  "block.minecraft.flower_pot": "Blómaker",
  "block.minecraft.flowering_azalea": "Blómstrandi Lyngrós",
  "block.minecraft.flowering_azalea_leaves": "Blómstrandi Lyngrósablöð",
  "block.minecraft.frogspawn": "Froskaegg",
  "block.minecraft.frosted_ice": "Frystur ís",
  "block.minecraft.furnace": "Ofn",
  "block.minecraft.gilded_blackstone": "Gyllt svartgrýti",
  "block.minecraft.glass": "Gler",
  "block.minecraft.glass_pane": "Glerrúða",
  "block.minecraft.glow_lichen": "Ljómandi Mosi",
  "block.minecraft.glowstone": "Glósteinn",
  "block.minecraft.gold_block": "Gullkubbur",
  "block.minecraft.gold_ore": "Gullgrýti",
  "block.minecraft.golden_dandelion": "Gullfífill",
  "block.minecraft.granite": "Granít",
  "block.minecraft.granite_slab": "Graníthella",
  "block.minecraft.granite_stairs": "Graníttröppur",
  "block.minecraft.granite_wall": "Granítveggur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Graskubbur",
  "block.minecraft.gravel": "Möl",
  "block.minecraft.gray_banner": "Grár fáni",
  "block.minecraft.gray_bed": "Grátt Rúm",
  "block.minecraft.gray_candle": "Grátt kerti",
  "block.minecraft.gray_candle_cake": "Kaka með gráu kerti",
  "block.minecraft.gray_carpet": "Grátt gólfteppi",
  "block.minecraft.gray_concrete": "Grá steinsteypa",
  "block.minecraft.gray_concrete_powder": "Grátt sement",
  "block.minecraft.gray_glazed_terracotta": "Grár glerjaður brenndur leir",
  "block.minecraft.gray_shulker_box": "Grátt hylki skálks",
  "block.minecraft.gray_stained_glass": "Grátt Litað Gler",
  "block.minecraft.gray_stained_glass_pane": "Lituð grá rúða",
  "block.minecraft.gray_terracotta": "Grátt keramik",
  "block.minecraft.gray_wool": "Grá ull",
  "block.minecraft.green_banner": "Grænn fáni",
  "block.minecraft.green_bed": "Grænt rúm",
  "block.minecraft.green_candle": "Grænt kerti",
  "block.minecraft.green_candle_cake": "Kaka með grænu kerti",
  "block.minecraft.green_carpet": "Grænt gólfteppi",
  "block.minecraft.green_concrete": "Græn steinsteypa",
  "block.minecraft.green_concrete_powder": "Grænt sement",
  "block.minecraft.green_glazed_terracotta": "Grænn glerjaður brenndur leir",
  "block.minecraft.green_shulker_box": "Grænt hylki skálks",
  "block.minecraft.green_stained_glass": "Grænlitað Gler",
  "block.minecraft.green_stained_glass_pane": "Lituð græn rúða",
  "block.minecraft.green_terracotta": "Grænt keramik",
  "block.minecraft.green_wool": "Græn ull",
  "block.minecraft.grindstone": "Smergel",
  "block.minecraft.hanging_roots": "Hangandi rætur",
  "block.minecraft.hay_block": "Heybaggi",
  "block.minecraft.heavy_core": "Þungkjarni",
  "block.minecraft.heavy_weighted_pressure_plate": "Þung þyngdarnæm þrýstihella",
  "block.minecraft.honey_block": "Hunangskubbur",
  "block.minecraft.honeycomb_block": "Vaxkökukubbur",
  "block.minecraft.hopper": "Trekt",
  "block.minecraft.horn_coral": "Hornakórall",
  "block.minecraft.horn_coral_block": "Hornakóralskubbur",
  "block.minecraft.horn_coral_fan": "Hornakóralsvængur",
  "block.minecraft.horn_coral_wall_fan": "Hornakóralsveggvængur",
  "block.minecraft.ice": "Klaki",
  "block.minecraft.infested_chiseled_stone_bricks": "Sýktur meitlaður steinmúr",
  "block.minecraft.infested_cobblestone": "Sýkt grjót",
  "block.minecraft.infested_cracked_stone_bricks": "Sýktur brotin steinmúr",
  "block.minecraft.infested_deepslate": "Sýkt djúpberg",
  "block.minecraft.infested_mossy_stone_bricks": "Sýktur mosagróin steinmúr",
  "block.minecraft.infested_stone": "Sýktur steinn",
  "block.minecraft.infested_stone_bricks": "Sýktur steinmúr",
  "block.minecraft.iron_bars": "Járnrimlar",
  "block.minecraft.iron_block": "Járnkubbur",
  "block.minecraft.iron_chain": "Járnkeðja",
  "block.minecraft.iron_door": "Járnhurð",
  "block.minecraft.iron_ore": "Járngrýti",
  "block.minecraft.iron_trapdoor": "Járnhleri",
  "block.minecraft.jack_o_lantern": "Ljósker",
  "block.minecraft.jigsaw": "Púsluspilskubbur",
  "block.minecraft.jukebox": "Glymskratti",
  "block.minecraft.jungle_button": "Frumskógarviðarhnappur",
  "block.minecraft.jungle_door": "Frumskógarviðarhurð",
  "block.minecraft.jungle_fence": "Frumskógarviðargirðing",
  "block.minecraft.jungle_fence_gate": "Frumskógarviðarhlið",
  "block.minecraft.jungle_hanging_sign": "Hangandi frumskógarviðarskilti",
  "block.minecraft.jungle_leaves": "Frumskógarlauf",
  "block.minecraft.jungle_log": "Frumskógardrumbur",
  "block.minecraft.jungle_planks": "Frumskógarplankar",
  "block.minecraft.jungle_pressure_plate": "Þrýstihella úr frumskógarviði",
  "block.minecraft.jungle_sapling": "Frumskógargræðlingur",
  "block.minecraft.jungle_shelf": "Frumskógarhilla",
  "block.minecraft.jungle_sign": "Frumskógarviðarskilti",
  "block.minecraft.jungle_slab": "Frumskógarviðarhella",
  "block.minecraft.jungle_stairs": "Frumskógarviðartröppur",
  "block.minecraft.jungle_trapdoor": "Frumskógarviðarhleri",
  "block.minecraft.jungle_wall_hanging_sign": "Vegghangandi frumskógarviðarskilti",
  "block.minecraft.jungle_wall_sign": "Frumskógarviðarskilti á vegg",
  "block.minecraft.jungle_wood": "Frumskógarviður",
  "block.minecraft.kelp": "Þari",
  "block.minecraft.kelp_plant": "Þaraplanta",
  "block.minecraft.ladder": "Stigi",
  "block.minecraft.lantern": "Lukt",
  "block.minecraft.lapis_block": "Blásteinskubbur",
  "block.minecraft.lapis_ore": "Asúrsteinn",
  "block.minecraft.large_amethyst_bud": "Stórt blákvarsbrum",
  "block.minecraft.large_fern": "Stór Runni",
  "block.minecraft.lava": "Hraun",
  "block.minecraft.lava_cauldron": "Kvikupottur",
  "block.minecraft.leaf_litter": "Hálmur",
  "block.minecraft.lectern": "Ræðupúlt",
  "block.minecraft.lever": "Rofi",
  "block.minecraft.light": "Ljós",
  "block.minecraft.light_blue_banner": "Ljósblár fáni",
  "block.minecraft.light_blue_bed": "Ljósblátt rúm",
  "block.minecraft.light_blue_candle": "Ljósblátt kerti",
  "block.minecraft.light_blue_candle_cake": "Kaka með ljósbláu kerti",
  "block.minecraft.light_blue_carpet": "Ljósblátt gólfteppi",
  "block.minecraft.light_blue_concrete": "Ljósblá steinsteypa",
  "block.minecraft.light_blue_concrete_powder": "Ljósblátt sement",
  "block.minecraft.light_blue_glazed_terracotta": "Ljósblár glerjaður brenndur leir",
  "block.minecraft.light_blue_shulker_box": "Ljósblátt hylki skálks",
  "block.minecraft.light_blue_stained_glass": "Ljós Blátt Litað Gler",
  "block.minecraft.light_blue_stained_glass_pane": "Lituð ljósblá rúða",
  "block.minecraft.light_blue_terracotta": "Ljósblátt keramik",
  "block.minecraft.light_blue_wool": "Ljósblá ull",
  "block.minecraft.light_gray_banner": "Ljósgrár fáni",
  "block.minecraft.light_gray_bed": "Ljósgrátt Rúm",
  "block.minecraft.light_gray_candle": "Ljósgrátt kerti",
  "block.minecraft.light_gray_candle_cake": "Kaka með ljósgráu kerti",
  "block.minecraft.light_gray_carpet": "Ljósgrátt gólfteppi",
  "block.minecraft.light_gray_concrete": "Ljósgrá steinsteypa",
  "block.minecraft.light_gray_concrete_powder": "Ljósgrátt sement",
  "block.minecraft.light_gray_glazed_terracotta": "Ljósgrár glerjaður brenndur leir",
  "block.minecraft.light_gray_shulker_box": "Ljósgrátt hylki skálks",
  "block.minecraft.light_gray_stained_glass": "Ljós Grátt Litað Gler",
  "block.minecraft.light_gray_stained_glass_pane": "Lituð ljós grá rúða",
  "block.minecraft.light_gray_terracotta": "Ljósgrátt keramik",
  "block.minecraft.light_gray_wool": "Ljósgrá ull",
  "block.minecraft.light_weighted_pressure_plate": "Létt þyngdarnæm þrýstihella",
  "block.minecraft.lightning_rod": "Eldingavari",
  "block.minecraft.lilac": "Sýrena",
  "block.minecraft.lily_of_the_valley": "Dalalilja",
  "block.minecraft.lily_pad": "Vatnalilja",
  "block.minecraft.lime_banner": "Límónugrænn fáni",
  "block.minecraft.lime_bed": "Ljósgrænt Rúm",
  "block.minecraft.lime_candle": "Ljósgrænt kerti",
  "block.minecraft.lime_candle_cake": "Kaka með ljósgrænu kerti",
  "block.minecraft.lime_carpet": "Ljósgrænt gólfteppi",
  "block.minecraft.lime_concrete": "Ljósgræn steinsteypa",
  "block.minecraft.lime_concrete_powder": "Ljósgrænt sement",
  "block.minecraft.lime_glazed_terracotta": "Ljósgrænn glerjaður brenndur leir",
  "block.minecraft.lime_shulker_box": "Ljósgrænt hylki skálks",
  "block.minecraft.lime_stained_glass": "Ljósgrænt Litað Gler",
  "block.minecraft.lime_stained_glass_pane": "Ljósgræn rúða",
  "block.minecraft.lime_terracotta": "Ljósgrænt keramik",
  "block.minecraft.lime_wool": "Ljósgræn ull",
  "block.minecraft.lodestone": "Varða",
  "block.minecraft.loom": "Vefstóll",
  "block.minecraft.magenta_banner": "Vínrauður fáni",
  "block.minecraft.magenta_bed": "Vínrautt rúm",
  "block.minecraft.magenta_candle": "Vínrautt kerti",
  "block.minecraft.magenta_candle_cake": "Kaka með vínrauðu kerti",
  "block.minecraft.magenta_carpet": "Vínrautt gólfteppi",
  "block.minecraft.magenta_concrete": "Vínrauð steinsteypa",
  "block.minecraft.magenta_concrete_powder": "Vínrautt sement",
  "block.minecraft.magenta_glazed_terracotta": "Vínrautt glerjað keramík",
  "block.minecraft.magenta_shulker_box": "Vínrautt hylki skálks",
  "block.minecraft.magenta_stained_glass": "Vínrautt Litað Gler",
  "block.minecraft.magenta_stained_glass_pane": "Vínrauð lituð rúða",
  "block.minecraft.magenta_terracotta": "Vínrautt keramik",
  "block.minecraft.magenta_wool": "Vínrauð ull",
  "block.minecraft.magma_block": "Kvikukubbur",
  "block.minecraft.mangrove_button": "Leiruviðarhnappur",
  "block.minecraft.mangrove_door": "Leiruviðarhurð",
  "block.minecraft.mangrove_fence": "Leiruviðargirðing",
  "block.minecraft.mangrove_fence_gate": "Hlið úr leiruvið",
  "block.minecraft.mangrove_hanging_sign": "Hangandi leiruviðarskilti",
  "block.minecraft.mangrove_leaves": "Leirulauf",
  "block.minecraft.mangrove_log": "Leiruviðardrumbur",
  "block.minecraft.mangrove_planks": "Leiruviðarplankar",
  "block.minecraft.mangrove_pressure_plate": "Þrýstihella úr leiruviði",
  "block.minecraft.mangrove_propagule": "Leiruviðargræðlingur",
  "block.minecraft.mangrove_roots": "Leiruviðarrætur",
  "block.minecraft.mangrove_shelf": "Leiruviðarhilla",
  "block.minecraft.mangrove_sign": "Leiruviðarskilti",
  "block.minecraft.mangrove_slab": "Leiruviðarhella",
  "block.minecraft.mangrove_stairs": "Leiruviðartröppur",
  "block.minecraft.mangrove_trapdoor": "Leiruviðarlúga",
  "block.minecraft.mangrove_wall_hanging_sign": "Vegghangandi leiruviðarskilti",
  "block.minecraft.mangrove_wall_sign": "Leiruviðarskilti á vegg",
  "block.minecraft.mangrove_wood": "Leiruviður",
  "block.minecraft.medium_amethyst_bud": "Miðlungsstórt blákvarsbrum",
  "block.minecraft.melon": "Melóna",
  "block.minecraft.melon_stem": "Melónustilkur",
  "block.minecraft.moss_block": "Mosakubbur",
  "block.minecraft.moss_carpet": "Mosateppi",
  "block.minecraft.mossy_cobblestone": "Mosagrjót",
  "block.minecraft.mossy_cobblestone_slab": "Mosavaxin götusteinshella",
  "block.minecraft.mossy_cobblestone_stairs": "Mosavaxnar Grjóttröppur",
  "block.minecraft.mossy_cobblestone_wall": "Mosagjrótveggur",
  "block.minecraft.mossy_stone_brick_slab": "Mosavaxin hleðslusteinshella",
  "block.minecraft.mossy_stone_brick_stairs": "Mosavaxnar hleðslusteinströppur",
  "block.minecraft.mossy_stone_brick_wall": "Mosavaxin hleðslusteinsveggur",
  "block.minecraft.mossy_stone_bricks": "Mosagróinn steinmúr",
  "block.minecraft.moving_piston": "Stimpill að hreyfast",
  "block.minecraft.mud": "Leðja",
  "block.minecraft.mud_brick_slab": "Leðjusteinshella",
  "block.minecraft.mud_brick_stairs": "Leðjusteinströppur",
  "block.minecraft.mud_brick_wall": "Leðjusteinsveggur",
  "block.minecraft.mud_bricks": "Leðjusteinn",
  "block.minecraft.muddy_mangrove_roots": "Drullugar leiruviðarrætur",
  "block.minecraft.mushroom_stem": "Sveppastafur",
  "block.minecraft.mycelium": "Svepparætur",
  "block.minecraft.nether_brick_fence": "Heljarmúrsgirðing",
  "block.minecraft.nether_brick_slab": "Heljarmúrsteinshella",
  "block.minecraft.nether_brick_stairs": "Heljarmúrsteinströppur",
  "block.minecraft.nether_brick_wall": "Heljarmúrsveggur",
  "block.minecraft.nether_bricks": "Heljarmúr",
  "block.minecraft.nether_gold_ore": "Heljargullgrýti",
  "block.minecraft.nether_portal": "Heljargátt",
  "block.minecraft.nether_quartz_ore": "Heljarkvarsgrýti",
  "block.minecraft.nether_sprouts": "Heljarspírur",
  "block.minecraft.nether_wart": "Heljarvarta",
  "block.minecraft.nether_wart_block": "Heljarvörtukubbur",
  "block.minecraft.netherite_block": "Heljarmálmskubbur",
  "block.minecraft.netherrack": "Heljargrjót",
  "block.minecraft.note_block": "Nótnakubbur",
  "block.minecraft.oak_button": "Eikarhnappur",
  "block.minecraft.oak_door": "Eikarhurð",
  "block.minecraft.oak_fence": "Eikargirðing",
  "block.minecraft.oak_fence_gate": "Eikarhlið",
  "block.minecraft.oak_hanging_sign": "Hangandi eikarskilti",
  "block.minecraft.oak_leaves": "Eikarlauf",
  "block.minecraft.oak_log": "Eikardrumbur",
  "block.minecraft.oak_planks": "Eikarplankar",
  "block.minecraft.oak_pressure_plate": "Þrýstihella úr eik",
  "block.minecraft.oak_sapling": "Eikargræðlingur",
  "block.minecraft.oak_shelf": "Eikarhilla",
  "block.minecraft.oak_sign": "Eikarskilti",
  "block.minecraft.oak_slab": "Eikarhella",
  "block.minecraft.oak_stairs": "Eikartröppur",
  "block.minecraft.oak_trapdoor": "Eikarhleri",
  "block.minecraft.oak_wall_hanging_sign": "Vegghangandi eikarskilti",
  "block.minecraft.oak_wall_sign": "Eikarskilti á vegg",
  "block.minecraft.oak_wood": "Eikarviður",
  "block.minecraft.observer": "Skynjari",
  "block.minecraft.obsidian": "Hrafntinna",
  "block.minecraft.ochre_froglight": "Okkurgul frosklugt",
  "block.minecraft.ominous_banner": "Váboðafáni",
  "block.minecraft.open_eyeblossom": "Opið augnablóm",
  "block.minecraft.orange_banner": "Appelsínugulur fáni",
  "block.minecraft.orange_bed": "Appelsínugult Rúm",
  "block.minecraft.orange_candle": "Appelsínugult kerti",
  "block.minecraft.orange_candle_cake": "Kaka með appelsínugulu kerti",
  "block.minecraft.orange_carpet": "Appelsínugult gólfteppi",
  "block.minecraft.orange_concrete": "Appelsínugul steinsteypa",
  "block.minecraft.orange_concrete_powder": "Appelsínugult sement",
  "block.minecraft.orange_glazed_terracotta": "Appelsínugulur glerjaður brenndur leir",
  "block.minecraft.orange_shulker_box": "Appelsínugult hylki skálks",
  "block.minecraft.orange_stained_glass": "Appelsínugult Gler",
  "block.minecraft.orange_stained_glass_pane": "Lituð appelsínugul rúða",
  "block.minecraft.orange_terracotta": "Appelnsínugult keramik",
  "block.minecraft.orange_tulip": "Appelsínugulur túlípani",
  "block.minecraft.orange_wool": "Appelsínugul ull",
  "block.minecraft.oxeye_daisy": "Freyjubrá",
  "block.minecraft.oxidized_chiseled_copper": "Oxaður meitlaður kopar",
  "block.minecraft.oxidized_copper": "Oxaður kopar",
  "block.minecraft.oxidized_copper_bars": "Oxaðir koparrimlar",
  "block.minecraft.oxidized_copper_bulb": "Oxuð koparpera",
  "block.minecraft.oxidized_copper_chain": "Oxuð koparkeðja",
  "block.minecraft.oxidized_copper_chest": "Oxuð koparkista",
  "block.minecraft.oxidized_copper_door": "Oxað koparhurð",
  "block.minecraft.oxidized_copper_golem_statue": "Oxuð koparþjarkar stytta",
  "block.minecraft.oxidized_copper_grate": "Oxuð kopargrind",
  "block.minecraft.oxidized_copper_lantern": "Oxuð koparlukt",
  "block.minecraft.oxidized_copper_trapdoor": "Oxað koparhleri",
  "block.minecraft.oxidized_cut_copper": "Oxaður skorinn kopar",
  "block.minecraft.oxidized_cut_copper_slab": "Oxuð skorin koparhella",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxaðar skornar kopartröppur",
  "block.minecraft.oxidized_lightning_rod": "Oxaður eldingavari",
  "block.minecraft.packed_ice": "Þjappaður ís",
  "block.minecraft.packed_mud": "Þjöppuð leðja",
  "block.minecraft.pale_hanging_moss": "Fölleitur hangandi mosi",
  "block.minecraft.pale_moss_block": "Fölleitur mosakubbur",
  "block.minecraft.pale_moss_carpet": "Fölleit mosabreiða",
  "block.minecraft.pale_oak_button": "Föleikarhnappur",
  "block.minecraft.pale_oak_door": "Ljós eikarhurð",
  "block.minecraft.pale_oak_fence": "Föleikargirðing",
  "block.minecraft.pale_oak_fence_gate": "Föleikarhlið",
  "block.minecraft.pale_oak_hanging_sign": "Hangandi föleikarskilti",
  "block.minecraft.pale_oak_leaves": "Föleikarlauf",
  "block.minecraft.pale_oak_log": "Föleikardrumbur",
  "block.minecraft.pale_oak_planks": "Föleikarplankar",
  "block.minecraft.pale_oak_pressure_plate": "Þrýstihella úr föleik",
  "block.minecraft.pale_oak_sapling": "Föleikargræðlingur",
  "block.minecraft.pale_oak_shelf": "Föleikarhilla",
  "block.minecraft.pale_oak_sign": "Föleikarskilti",
  "block.minecraft.pale_oak_slab": "Föleikarplata",
  "block.minecraft.pale_oak_stairs": "Föleikartröppur",
  "block.minecraft.pale_oak_trapdoor": "Föleikarhleri",
  "block.minecraft.pale_oak_wall_hanging_sign": "Vegghangandi föleikarskilti",
  "block.minecraft.pale_oak_wall_sign": "Föleikarskilti á vegg",
  "block.minecraft.pale_oak_wood": "Föleikarviður",
  "block.minecraft.pearlescent_froglight": "Perlublá frosklugt",
  "block.minecraft.peony": "Bóndarós",
  "block.minecraft.petrified_oak_slab": "Steinrunnin eikarhella",
  "block.minecraft.piglin_head": "Svínungshaus",
  "block.minecraft.piglin_wall_head": "Svínungshaus á vegg",
  "block.minecraft.pink_banner": "Bleikur fáni",
  "block.minecraft.pink_bed": "Bleikt Rúm",
  "block.minecraft.pink_candle": "Bleikt kerti",
  "block.minecraft.pink_candle_cake": "Kaka með bleiku kerti",
  "block.minecraft.pink_carpet": "Bleikt gólfteppi",
  "block.minecraft.pink_concrete": "Bleik steinsteypa",
  "block.minecraft.pink_concrete_powder": "Bleikt sement",
  "block.minecraft.pink_glazed_terracotta": "Bleikur glerjaður brenndur leir",
  "block.minecraft.pink_petals": "Bleik krónublöð",
  "block.minecraft.pink_shulker_box": "Bleikt hylki skálks",
  "block.minecraft.pink_stained_glass": "Bleikt Litað Gler",
  "block.minecraft.pink_stained_glass_pane": "Lituð bleik rúða",
  "block.minecraft.pink_terracotta": "Bleikt keramik",
  "block.minecraft.pink_tulip": "Bleikur túlípani",
  "block.minecraft.pink_wool": "Bleik ull",
  "block.minecraft.piston": "Stimpill",
  "block.minecraft.piston_head": "Stimpilhaus",
  "block.minecraft.pitcher_crop": "Gildrublaðuppskera",
  "block.minecraft.pitcher_plant": "Gildrublaðplanta",
  "block.minecraft.player_head": "Spilarahöfuð",
  "block.minecraft.player_head.named": "Haus %ss",
  "block.minecraft.player_wall_head": "Leikmannshaus á vegg",
  "block.minecraft.podzol": "Mór",
  "block.minecraft.pointed_dripstone": "Oddhvass Dropasteinn",
  "block.minecraft.polished_andesite": "Slípað andesít",
  "block.minecraft.polished_andesite_slab": "Slípuð andesíthella",
  "block.minecraft.polished_andesite_stairs": "Slípaðar andesíttröppur",
  "block.minecraft.polished_basalt": "Slípað basalt",
  "block.minecraft.polished_blackstone": "Slípað svartgrýti",
  "block.minecraft.polished_blackstone_brick_slab": "Slípuð svartgrýtismúrsteinshella",
  "block.minecraft.polished_blackstone_brick_stairs": "Slípaðar svartgrýtismúrsteinströppur",
  "block.minecraft.polished_blackstone_brick_wall": "Slípaður svartgrýtismúrsteinsmúr",
  "block.minecraft.polished_blackstone_bricks": "Slípaðir svartgrýtismúrsteinar",
  "block.minecraft.polished_blackstone_button": "Slípaður svartgrýtishnappur",
  "block.minecraft.polished_blackstone_pressure_plate": "Slípuð svartgrýtisþrýstihella",
  "block.minecraft.polished_blackstone_slab": "Slípuð svartgrýtishella",
  "block.minecraft.polished_blackstone_stairs": "Slípaðar svartgrýtiströppur",
  "block.minecraft.polished_blackstone_wall": "Slípaður svartgrýtismúr",
  "block.minecraft.polished_deepslate": "Slípað djúpberg",
  "block.minecraft.polished_deepslate_slab": "Slípuð djúpbergshella",
  "block.minecraft.polished_deepslate_stairs": "Slípaðar djúpbergströppur",
  "block.minecraft.polished_deepslate_wall": "Slípaður djúpbergsveggur",
  "block.minecraft.polished_diorite": "Slípað díórít",
  "block.minecraft.polished_diorite_slab": "Slípuð díóríthella",
  "block.minecraft.polished_diorite_stairs": "Slípaðar díóríttröppur",
  "block.minecraft.polished_granite": "Slípað granít",
  "block.minecraft.polished_granite_slab": "Slípuð graníthella",
  "block.minecraft.polished_granite_stairs": "Slípaðar graníttröppur",
  "block.minecraft.polished_tuff": "Slípað móberg",
  "block.minecraft.polished_tuff_slab": "Slípað móbergshella",
  "block.minecraft.polished_tuff_stairs": "Slípað móbergströppur",
  "block.minecraft.polished_tuff_wall": "Slípað móbergsveggur",
  "block.minecraft.poppy": "Valmúi",
  "block.minecraft.potatoes": "Kartöflur",
  "block.minecraft.potted_acacia_sapling": "Pottsettur akasíugræðlingur",
  "block.minecraft.potted_allium": "Kúlulaukur í potti",
  "block.minecraft.potted_azalea_bush": "Lyngrós í potti",
  "block.minecraft.potted_azure_bluet": "Hrafnaklukka í potti",
  "block.minecraft.potted_bamboo": "Bambus í potti",
  "block.minecraft.potted_birch_sapling": "Pottsettur birkigræðlingur",
  "block.minecraft.potted_blue_orchid": "Blá orkídea í potti",
  "block.minecraft.potted_brown_mushroom": "Brúnn sveppur í potti",
  "block.minecraft.potted_cactus": "Kaktus í potti",
  "block.minecraft.potted_cherry_sapling": "Kirsuberjagræðlingur í potti",
  "block.minecraft.potted_closed_eyeblossom": "Lokað augnablóm í potti",
  "block.minecraft.potted_cornflower": "Garðakornblóm í potti",
  "block.minecraft.potted_crimson_fungus": "Hárauður sveppur í potti",
  "block.minecraft.potted_crimson_roots": "Hárautt heljargras í potti",
  "block.minecraft.potted_dandelion": "Fífill í potti",
  "block.minecraft.potted_dark_oak_sapling": "Pottsettur dökkeikargræðlingur",
  "block.minecraft.potted_dead_bush": "Dauður runni í potti",
  "block.minecraft.potted_fern": "Burkni í potti",
  "block.minecraft.potted_flowering_azalea_bush": "Blómstrandi lyngrós í potti",
  "block.minecraft.potted_golden_dandelion": "Gullfífill í blómapotti",
  "block.minecraft.potted_jungle_sapling": "Frumskógargræðlingur í potti",
  "block.minecraft.potted_lily_of_the_valley": "Dalalilja í potti",
  "block.minecraft.potted_mangrove_propagule": "Leiruviðaræxlikorn í potti",
  "block.minecraft.potted_oak_sapling": "Pottsettur eikargræðlingur",
  "block.minecraft.potted_open_eyeblossom": "Opið augnablóm í potti",
  "block.minecraft.potted_orange_tulip": "Appelsínugulur túlípani í potti",
  "block.minecraft.potted_oxeye_daisy": "Freyjubrá í potti",
  "block.minecraft.potted_pale_oak_sapling": "Pottsettur föleikargræðlingur",
  "block.minecraft.potted_pink_tulip": "Bleikur túlípani í potti",
  "block.minecraft.potted_poppy": "Valmúi í potti",
  "block.minecraft.potted_red_mushroom": "Rauður sveppur í potti",
  "block.minecraft.potted_red_tulip": "Rauður túlípani í potti",
  "block.minecraft.potted_spruce_sapling": "Pottsettur grenigræðlingur",
  "block.minecraft.potted_torchflower": "Kyndilblóm í potti",
  "block.minecraft.potted_warped_fungus": "Brenglaður sveppur í potti",
  "block.minecraft.potted_warped_roots": "Brenglað heljargras í potti",
  "block.minecraft.potted_white_tulip": "Hvítur túlípani í potti",
  "block.minecraft.potted_wither_rose": "Visnuð rós í potti",
  "block.minecraft.powder_snow": "Lausamjöll",
  "block.minecraft.powder_snow_cauldron": "Lausamjallarpottur",
  "block.minecraft.powered_rail": "Orku teinar",
  "block.minecraft.prismarine": "Hafsteinn",
  "block.minecraft.prismarine_brick_slab": "Prismarínmúrsteinshella",
  "block.minecraft.prismarine_brick_stairs": "Hafmúrsteinströppur",
  "block.minecraft.prismarine_bricks": "Hafmúrsteinar",
  "block.minecraft.prismarine_slab": "Prismarínhella",
  "block.minecraft.prismarine_stairs": "Hafsteinströppur",
  "block.minecraft.prismarine_wall": "Hafsteinsveggur",
  "block.minecraft.pumpkin": "Grasker",
  "block.minecraft.pumpkin_stem": "Graskerstilkur",
  "block.minecraft.purple_banner": "Fjólublár fáni",
  "block.minecraft.purple_bed": "Fjólublátt Rúm",
  "block.minecraft.purple_candle": "Fjólublátt kerti",
  "block.minecraft.purple_candle_cake": "Kaka með fjólubláu kerti",
  "block.minecraft.purple_carpet": "Fjólublátt gólfteppi",
  "block.minecraft.purple_concrete": "Fjólublá steinsteypa",
  "block.minecraft.purple_concrete_powder": "Fjólublátt sement",
  "block.minecraft.purple_glazed_terracotta": "Fjólublár glerjaður brenndur leir",
  "block.minecraft.purple_shulker_box": "Fjólublátt hylki skálks",
  "block.minecraft.purple_stained_glass": "Fjólublátt litað gler",
  "block.minecraft.purple_stained_glass_pane": "Fjólublá rúða",
  "block.minecraft.purple_terracotta": "Fjólublátt keramik",
  "block.minecraft.purple_wool": "Fjólublá ull",
  "block.minecraft.purpur_block": "Purpurakubbur",
  "block.minecraft.purpur_pillar": "Purpurasúla",
  "block.minecraft.purpur_slab": "Purpurahella",
  "block.minecraft.purpur_stairs": "Purpuratröppur",
  "block.minecraft.quartz_block": "Kvarskubbur",
  "block.minecraft.quartz_bricks": "Heljarkvarsmúr",
  "block.minecraft.quartz_pillar": "Kvarssúla",
  "block.minecraft.quartz_slab": "Kvarshella",
  "block.minecraft.quartz_stairs": "Kvarströppur",
  "block.minecraft.rail": "Járnbraut",
  "block.minecraft.raw_copper_block": "Kubbur af hrákopar",
  "block.minecraft.raw_gold_block": "Kubbur af hrágulli",
  "block.minecraft.raw_iron_block": "Kubbur af hrájárni",
  "block.minecraft.red_banner": "Rauður fáni",
  "block.minecraft.red_bed": "Rautt Rúm",
  "block.minecraft.red_candle": "Rautt kerti",
  "block.minecraft.red_candle_cake": "Kaka með gráu kerti",
  "block.minecraft.red_carpet": "Rautt gólfteppi",
  "block.minecraft.red_concrete": "Rauð steinsteypa",
  "block.minecraft.red_concrete_powder": "Rautt sement",
  "block.minecraft.red_glazed_terracotta": "Rauður glerjaður brenndur leir",
  "block.minecraft.red_mushroom": "Fansveppur",
  "block.minecraft.red_mushroom_block": "Rauður sveppakubbur",
  "block.minecraft.red_nether_brick_slab": "Rauð heljarmúrshella",
  "block.minecraft.red_nether_brick_stairs": "Rauðar heljarmúrströppur",
  "block.minecraft.red_nether_brick_wall": "Rauður heljarmúrsveggur",
  "block.minecraft.red_nether_bricks": "Rauður heljarmúr",
  "block.minecraft.red_sand": "Rauður sandur",
  "block.minecraft.red_sandstone": "Rauður sandsteinn",
  "block.minecraft.red_sandstone_slab": "Rauð sandsteinshella",
  "block.minecraft.red_sandstone_stairs": "Rauðar sandsteinströppur",
  "block.minecraft.red_sandstone_wall": "Rauður sandsteinsveggur",
  "block.minecraft.red_shulker_box": "Rautt hylki skálks",
  "block.minecraft.red_stained_glass": "Rauð Litað Gler",
  "block.minecraft.red_stained_glass_pane": "Lituð rauð rúða",
  "block.minecraft.red_terracotta": "Rautt keramik",
  "block.minecraft.red_tulip": "Rauður túlípani",
  "block.minecraft.red_wool": "Rauð ull",
  "block.minecraft.redstone_block": "Roðsteinskubbur",
  "block.minecraft.redstone_lamp": "Roðsteinslampi",
  "block.minecraft.redstone_ore": "Roðsteinsgrýti",
  "block.minecraft.redstone_torch": "Roðsteinskyndill",
  "block.minecraft.redstone_wall_torch": "Rauðsteinskyndill á vegg",
  "block.minecraft.redstone_wire": "Roðasteinsvír",
  "block.minecraft.reinforced_deepslate": "Styrkt djúpberg",
  "block.minecraft.repeater": "Roðsteinsmagnari",
  "block.minecraft.repeating_command_block": "Endurtakandi forritunarkubbur",
  "block.minecraft.resin_block": "Kvoðublokk",
  "block.minecraft.resin_brick_slab": "Kvoðusteinshella",
  "block.minecraft.resin_brick_stairs": "Kvoðusteinströppur",
  "block.minecraft.resin_brick_wall": "Kvoðusteinsveggur",
  "block.minecraft.resin_bricks": "Kvoðusteinar",
  "block.minecraft.resin_clump": "Kvoðuköggull",
  "block.minecraft.respawn_anchor": "Endurlífgunar akkeri",
  "block.minecraft.rooted_dirt": "Rótuð mold",
  "block.minecraft.rose_bush": "Rósarunni",
  "block.minecraft.sand": "Sandur",
  "block.minecraft.sandstone": "Sandsteinn",
  "block.minecraft.sandstone_slab": "Sandsteinshella",
  "block.minecraft.sandstone_stairs": "Sandsteinströppur",
  "block.minecraft.sandstone_wall": "Sandsteinsveggur",
  "block.minecraft.scaffolding": "Vinnupallur",
  "block.minecraft.sculk": "Skelkur",
  "block.minecraft.sculk_catalyst": "Skelkshvati",
  "block.minecraft.sculk_sensor": "Skelksnemi",
  "block.minecraft.sculk_shrieker": "Skelksskrækir",
  "block.minecraft.sculk_vein": "Skelksæð",
  "block.minecraft.sea_lantern": "Haflukt",
  "block.minecraft.sea_pickle": "Sæbjúga",
  "block.minecraft.seagrass": "Sægras",
  "block.minecraft.set_spawn": "Endurlífgunarstaður settur",
  "block.minecraft.short_dry_grass": "Lágt þurrt gras",
  "block.minecraft.short_grass": "Lágt gras",
  "block.minecraft.shroomlight": "Sveppaljós",
  "block.minecraft.shulker_box": "Hylki skálks",
  "block.minecraft.skeleton_skull": "Hauskúpa",
  "block.minecraft.skeleton_wall_skull": "Hauskúpa á vegg",
  "block.minecraft.slime_block": "Slímkubbur",
  "block.minecraft.small_amethyst_bud": "Lítið blákvarsbrum",
  "block.minecraft.small_dripleaf": "Lítið Hallalauf",
  "block.minecraft.smithing_table": "Járnsmíðabekkur",
  "block.minecraft.smoker": "Reykofn",
  "block.minecraft.smooth_basalt": "Slétt basalt",
  "block.minecraft.smooth_quartz": "Sléttur kvarskubbur",
  "block.minecraft.smooth_quartz_slab": "Slétt kvarshella",
  "block.minecraft.smooth_quartz_stairs": "Sléttar kvarströppur",
  "block.minecraft.smooth_red_sandstone": "Sléttur rauður sandsteinn",
  "block.minecraft.smooth_red_sandstone_slab": "Sléttar roðasandsteinshella",
  "block.minecraft.smooth_red_sandstone_stairs": "Sléttar roðasandsteinströppur",
  "block.minecraft.smooth_sandstone": "Sléttur sandsteinn",
  "block.minecraft.smooth_sandstone_slab": "Slétt sandsteinshella",
  "block.minecraft.smooth_sandstone_stairs": "Sléttar sandsteinströppur",
  "block.minecraft.smooth_stone": "Sléttur steinn",
  "block.minecraft.smooth_stone_slab": "Slípuð steinhella",
  "block.minecraft.sniffer_egg": "Þefaraegg",
  "block.minecraft.snow": "Snjór",
  "block.minecraft.snow_block": "Snjókubbur",
  "block.minecraft.soul_campfire": "Sálarvarðeldur",
  "block.minecraft.soul_fire": "Sálareldur",
  "block.minecraft.soul_lantern": "Sálarlukt",
  "block.minecraft.soul_sand": "Sálarsandur",
  "block.minecraft.soul_soil": "Sálarmold",
  "block.minecraft.soul_torch": "Sálarkyndill",
  "block.minecraft.soul_wall_torch": "Veggkyndill með sálareldi",
  "block.minecraft.spawn.not_valid": "Þú átt ekki neitt rúm eða hlaðið endurlífgunarakkeri, eða það eyðilagðist",
  "block.minecraft.spawner": "Skrímslabúr",
  "block.minecraft.spawner.desc1": "Samskipti með framköllunareggi:",
  "block.minecraft.spawner.desc2": "Stillir tegund veru",
  "block.minecraft.sponge": "Svampur",
  "block.minecraft.spore_blossom": "Bergsóley",
  "block.minecraft.spruce_button": "Grenihnappur",
  "block.minecraft.spruce_door": "Grenihurð",
  "block.minecraft.spruce_fence": "Grenigirðing",
  "block.minecraft.spruce_fence_gate": "Grenihlið",
  "block.minecraft.spruce_hanging_sign": "Hangandi greiniskilti",
  "block.minecraft.spruce_leaves": "Greninálar",
  "block.minecraft.spruce_log": "Grenidrumbur",
  "block.minecraft.spruce_planks": "Greniplankar",
  "block.minecraft.spruce_pressure_plate": "Þrýstihella úr greni",
  "block.minecraft.spruce_sapling": "Grenigræðlingur",
  "block.minecraft.spruce_shelf": "Grenihilla",
  "block.minecraft.spruce_sign": "Greniskilti",
  "block.minecraft.spruce_slab": "Grenihella",
  "block.minecraft.spruce_stairs": "Grenitröppur",
  "block.minecraft.spruce_trapdoor": "Grenihleri",
  "block.minecraft.spruce_wall_hanging_sign": "Vegghangandi greniskilti",
  "block.minecraft.spruce_wall_sign": "Greniskilti á vegg",
  "block.minecraft.spruce_wood": "Greniviður",
  "block.minecraft.sticky_piston": "Klístraður stimpill",
  "block.minecraft.stone": "Steinn",
  "block.minecraft.stone_brick_slab": "Steinmúrhella",
  "block.minecraft.stone_brick_stairs": "Steinmúrströppur",
  "block.minecraft.stone_brick_wall": "Hleðslusteinsveggur",
  "block.minecraft.stone_bricks": "Steinmúr",
  "block.minecraft.stone_button": "Steinshnappur",
  "block.minecraft.stone_pressure_plate": "Þrýstihella úr steini",
  "block.minecraft.stone_slab": "Steinhella",
  "block.minecraft.stone_stairs": "Steintröppur",
  "block.minecraft.stonecutter": "Steinskeri",
  "block.minecraft.stripped_acacia_log": "Heflaður akasíudrumbur",
  "block.minecraft.stripped_acacia_wood": "Heflaður akasíuviður",
  "block.minecraft.stripped_bamboo_block": "Rifinn bambuskubbur",
  "block.minecraft.stripped_birch_log": "Heflaður birkidrumbur",
  "block.minecraft.stripped_birch_wood": "Heflaður birkiviður",
  "block.minecraft.stripped_cherry_log": "Afrifinn kirsuberjadrumbur",
  "block.minecraft.stripped_cherry_wood": "Afrifinn kirsuberjaviður",
  "block.minecraft.stripped_crimson_hyphae": "Strípaðir hárauðir sveppaþræðir",
  "block.minecraft.stripped_crimson_stem": "Strípaður hárauður stilkur",
  "block.minecraft.stripped_dark_oak_log": "Heflaður dökkeikardrumbur",
  "block.minecraft.stripped_dark_oak_wood": "Heflaður dökkeikarviður",
  "block.minecraft.stripped_jungle_log": "Heflaður frumskógardrumbur",
  "block.minecraft.stripped_jungle_wood": "Heflaður frumskógarviður",
  "block.minecraft.stripped_mangrove_log": "Heflaður leiruviðardrumbur",
  "block.minecraft.stripped_mangrove_wood": "Heflaður leiruviður",
  "block.minecraft.stripped_oak_log": "Heflaður eikardrumbur",
  "block.minecraft.stripped_oak_wood": "Heflaður eikarviður",
  "block.minecraft.stripped_pale_oak_log": "Heflaður föleikardrumbur",
  "block.minecraft.stripped_pale_oak_wood": "Heflaður föleikarviður",
  "block.minecraft.stripped_spruce_log": "Heflaður grenidrumbur",
  "block.minecraft.stripped_spruce_wood": "Heflaður greniviður",
  "block.minecraft.stripped_warped_hyphae": "Heflaðir brenglaðir sveppaþræðir",
  "block.minecraft.stripped_warped_stem": "Afrifinn brenglaður stofn",
  "block.minecraft.structure_block": "Byggingarkubbur",
  "block.minecraft.structure_void": "Tómarúmsbygging",
  "block.minecraft.sugar_cane": "Sykurreyr",
  "block.minecraft.sunflower": "Sólblóm",
  "block.minecraft.suspicious_gravel": "Grunsamleg möl",
  "block.minecraft.suspicious_sand": "Grunsamlegur sandur",
  "block.minecraft.sweet_berry_bush": "Sætuberjarunni",
  "block.minecraft.tall_dry_grass": "Hátt þurrt gras",
  "block.minecraft.tall_grass": "Hátt Gras",
  "block.minecraft.tall_seagrass": "Hátt sægras",
  "block.minecraft.target": "Skotmark",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Prufukubbur",
  "block.minecraft.test_instance_block": "Prufutilvikskubbur",
  "block.minecraft.tinted_glass": "Litað gler",
  "block.minecraft.tnt": "Sprengiefni",
  "block.minecraft.tnt.disabled": "Íkveikja sprengiefna er óvirk",
  "block.minecraft.torch": "Kyndill",
  "block.minecraft.torchflower": "Kyndilblóm",
  "block.minecraft.torchflower_crop": "Kyndilblómauppskera",
  "block.minecraft.trapped_chest": "Gildrukista",
  "block.minecraft.trial_spawner": "Þrautaframkallari",
  "block.minecraft.tripwire": "Vírgildra",
  "block.minecraft.tripwire_hook": "Vírkrækja",
  "block.minecraft.tube_coral": "Pípukórall",
  "block.minecraft.tube_coral_block": "Pípukóralskubbur",
  "block.minecraft.tube_coral_fan": "Pípukóralsvængur",
  "block.minecraft.tube_coral_wall_fan": "Pípukóralsveggvængur",
  "block.minecraft.tuff": "Móberg",
  "block.minecraft.tuff_brick_slab": "Móbergsmúrshella",
  "block.minecraft.tuff_brick_stairs": "Móbergsmúrströppur",
  "block.minecraft.tuff_brick_wall": "Móbergsmúrsveggur",
  "block.minecraft.tuff_bricks": "Móbergssteinar",
  "block.minecraft.tuff_slab": "Móbergshella",
  "block.minecraft.tuff_stairs": "Móbergströppur",
  "block.minecraft.tuff_wall": "Móbergsveggur",
  "block.minecraft.turtle_egg": "Skjaldbökuegg",
  "block.minecraft.twisting_vines": "Vafningsviður",
  "block.minecraft.twisting_vines_plant": "Vafningsviðarplanta",
  "block.minecraft.vault": "Hvelfing",
  "block.minecraft.verdant_froglight": "Skrúðgræn frosklugt",
  "block.minecraft.vine": "Klifurjurt",
  "block.minecraft.void_air": "Tómaloft",
  "block.minecraft.wall_torch": "Kyndill á vegg",
  "block.minecraft.warped_button": "Brenglaður hnappur",
  "block.minecraft.warped_door": "Brengluð hurð",
  "block.minecraft.warped_fence": "Brengluð girðing",
  "block.minecraft.warped_fence_gate": "Brenglað hlið",
  "block.minecraft.warped_fungus": "Brenglaður sveppur",
  "block.minecraft.warped_hanging_sign": "Hangandi brenglað skilti",
  "block.minecraft.warped_hyphae": "Brenglaðir sveppaþræðir",
  "block.minecraft.warped_nylium": "Brenglað heljarmygli",
  "block.minecraft.warped_planks": "Brenglaðirplankar",
  "block.minecraft.warped_pressure_plate": "Brengluð þrýstihella",
  "block.minecraft.warped_roots": "Brenglað heljargras",
  "block.minecraft.warped_shelf": "Brengluðhilla",
  "block.minecraft.warped_sign": "Brenglað skilti",
  "block.minecraft.warped_slab": "Brengluð hella",
  "block.minecraft.warped_stairs": "Brenglaðar tröppur",
  "block.minecraft.warped_stem": "Brenglaður stofn",
  "block.minecraft.warped_trapdoor": "Brenglaður hleri",
  "block.minecraft.warped_wall_hanging_sign": "Vegghangandi brenglað skilti",
  "block.minecraft.warped_wall_sign": "Brenglað Veggskilti",
  "block.minecraft.warped_wart_block": "Brenglaður heljarvörtukubbur",
  "block.minecraft.water": "Vatn",
  "block.minecraft.water_cauldron": "Vatnspottur",
  "block.minecraft.waxed_chiseled_copper": "Vaxborinn meitlaður kopar",
  "block.minecraft.waxed_copper_bars": "Vaxbornir koparrimlar",
  "block.minecraft.waxed_copper_block": "Vaxhúðaður kubbur af kopar",
  "block.minecraft.waxed_copper_bulb": "Vaxborin koparpera",
  "block.minecraft.waxed_copper_chain": "Vaxborin koparkeðja",
  "block.minecraft.waxed_copper_chest": "Vaxborin koparkista",
  "block.minecraft.waxed_copper_door": "Vaxborin koparhurð",
  "block.minecraft.waxed_copper_golem_statue": "Vaxborin koparþjarkar stytta",
  "block.minecraft.waxed_copper_grate": "Vaxborin kopargrind",
  "block.minecraft.waxed_copper_lantern": "Vaxborin koparlukt",
  "block.minecraft.waxed_copper_trapdoor": "Vaxborinn koparhleri",
  "block.minecraft.waxed_cut_copper": "Bónaður skorinn kopar",
  "block.minecraft.waxed_cut_copper_slab": "Bónuð skorin koparhella",
  "block.minecraft.waxed_cut_copper_stairs": "Vaxbornar skornar kopartröppur",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaxborinn óvarinn meitlaður kopar",
  "block.minecraft.waxed_exposed_copper": "Vaxborinn óvarinn kopar",
  "block.minecraft.waxed_exposed_copper_bars": "Vaxbornir óvarnir koparrimlar",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaxborin óvarin koparpera",
  "block.minecraft.waxed_exposed_copper_chain": "Vaxborin óvarin koparkeðja",
  "block.minecraft.waxed_exposed_copper_chest": "Vaxborin óvarin koparkista",
  "block.minecraft.waxed_exposed_copper_door": "Vaxborin óvarin koparhurð",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaxborin óvarin koparþjarkar stytta",
  "block.minecraft.waxed_exposed_copper_grate": "Vaxborin óvarin kopargrind",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaxborin óvarin koparlukt",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaxborinn óvarinn koparhleri",
  "block.minecraft.waxed_exposed_cut_copper": "Vaxborinn óvarinn skorin kopar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaxborin óvarin skorin koparhella",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaxbornar óvarðar skornar kopartröppur",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaxborinn óvarinn eldingavari",
  "block.minecraft.waxed_lightning_rod": "Vaxborinn eldingavari",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaxborinn oxaður meitlaður kopar",
  "block.minecraft.waxed_oxidized_copper": "Vaxborinn oxaður kopar",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaxbornir oxaðir koparrimlar",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaxborin oxuð koparpera",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaxborin oxuð koparkeðja",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaxborin oxuð koparkista",
  "block.minecraft.waxed_oxidized_copper_door": "Vaxborin oxuð koparhurð",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaxborin oxuð koparþjarkar stytta",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaxborin oxuð kopargind",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaxborin oxuð koparlukt",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaxborinn oxaður koparhleri",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaxborinn oxaður skorinn kopar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaxborin oxuð skorin koparhella",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaxbornar oxaðar skornar kopartröppur",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaxborinn oxaður eldingavari",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaxborinn veðraður meitlaður kopar",
  "block.minecraft.waxed_weathered_copper": "Vaxborinn veðraður kopar",
  "block.minecraft.waxed_weathered_copper_bars": "Vaxbornir veðrarið koparrimlar",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaxborin veðruð koparpera",
  "block.minecraft.waxed_weathered_copper_chain": "Vaxborin veðruð koparkeðja",
  "block.minecraft.waxed_weathered_copper_chest": "Vaxborin veðruð koparkista",
  "block.minecraft.waxed_weathered_copper_door": "Vaxborin veðruð koparhurð",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaxborin veðruð koparþjarkar stytta",
  "block.minecraft.waxed_weathered_copper_grate": "Vaxborin veðruð kopargrind",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaxborin veðruð koparlukt",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaxborinn veðraður koparhleri",
  "block.minecraft.waxed_weathered_cut_copper": "Vaxborinn veðraður skorinn kopar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaxborin veðruð skorin koparhella",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaxbornar veðraðar skornar kopartröppur",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaxborinn veðraður eldingavari",
  "block.minecraft.weathered_chiseled_copper": "Veðraður meitlaður kopar",
  "block.minecraft.weathered_copper": "Veðraður kopar",
  "block.minecraft.weathered_copper_bars": "Veðrarið koparrimlar",
  "block.minecraft.weathered_copper_bulb": "Veðruð koparpera",
  "block.minecraft.weathered_copper_chain": "Veðruð koparkeðja",
  "block.minecraft.weathered_copper_chest": "Veðruð koparkista",
  "block.minecraft.weathered_copper_door": "Veðruð koparhurð",
  "block.minecraft.weathered_copper_golem_statue": "Veðruð koparþjarkar stytta",
  "block.minecraft.weathered_copper_grate": "Veðruð kopargrind",
  "block.minecraft.weathered_copper_lantern": "Veðruð koparlukt",
  "block.minecraft.weathered_copper_trapdoor": "Veðraður Koparhleri",
  "block.minecraft.weathered_cut_copper": "Veðraður skorinn kopar",
  "block.minecraft.weathered_cut_copper_slab": "Veðruð skorin koparhella",
  "block.minecraft.weathered_cut_copper_stairs": "Veðraðar skornar kopartröppur",
  "block.minecraft.weathered_lightning_rod": "Veðraður eldingavari",
  "block.minecraft.weeping_vines": "Grátsvínviður",
  "block.minecraft.weeping_vines_plant": "Lafviður",
  "block.minecraft.wet_sponge": "Blautur svampur",
  "block.minecraft.wheat": "Hveitiuppskerur",
  "block.minecraft.white_banner": "Hvítur fáni",
  "block.minecraft.white_bed": "Hvítt Rúm",
  "block.minecraft.white_candle": "Hvítt kerti",
  "block.minecraft.white_candle_cake": "Kaka með hvítu kerti",
  "block.minecraft.white_carpet": "Hvítt gólfteppi",
  "block.minecraft.white_concrete": "Hvít steinsteypa",
  "block.minecraft.white_concrete_powder": "Hvítt sement",
  "block.minecraft.white_glazed_terracotta": "Hvítur glerjaður brenndur leir",
  "block.minecraft.white_shulker_box": "Hvítt hylki skálks",
  "block.minecraft.white_stained_glass": "Hvítt litað gler",
  "block.minecraft.white_stained_glass_pane": "Hvítlituð rúða",
  "block.minecraft.white_terracotta": "Hvítt keramik",
  "block.minecraft.white_tulip": "Hvítur túlípani",
  "block.minecraft.white_wool": "Hvít ull",
  "block.minecraft.wildflowers": "Villiblóm",
  "block.minecraft.wither_rose": "Visnuð rós",
  "block.minecraft.wither_skeleton_skull": "Hauskúpa viðrinisbeinagrindar",
  "block.minecraft.wither_skeleton_wall_skull": "Hauskúpa viðrinisbeinagrindar á vegg",
  "block.minecraft.yellow_banner": "Gulur fáni",
  "block.minecraft.yellow_bed": "Gult Rúm",
  "block.minecraft.yellow_candle": "Gult kerti",
  "block.minecraft.yellow_candle_cake": "Kaka með gulu kerti",
  "block.minecraft.yellow_carpet": "Gult teppi",
  "block.minecraft.yellow_concrete": "Gul steinsteypa",
  "block.minecraft.yellow_concrete_powder": "Gult sement",
  "block.minecraft.yellow_glazed_terracotta": "Gulur glerjaður brenndur leir",
  "block.minecraft.yellow_shulker_box": "Gult hylki skálks",
  "block.minecraft.yellow_stained_glass": "Gul Litað Gler",
  "block.minecraft.yellow_stained_glass_pane": "Lituð gul rúða",
  "block.minecraft.yellow_terracotta": "Gult keramik",
  "block.minecraft.yellow_wool": "Gul ull",
  "block.minecraft.zombie_head": "Höfuð uppvaknings",
  "block.minecraft.zombie_wall_head": "Uppvakningshaus á vegg",
  "item.minecraft.acacia_boat": "Akasíubátur",
  "item.minecraft.acacia_chest_boat": "Akasíubátur með kistu",
  "item.minecraft.allay_spawn_egg": "Lífegg hjálpara",
  "item.minecraft.amethyst_shard": "Blákvarsflís",
  "item.minecraft.angler_pottery_shard": "Fiskimannsbrot",
  "item.minecraft.angler_pottery_sherd": "Fiskimannsbrot",
  "item.minecraft.apple": "Epli",
  "item.minecraft.archer_pottery_shard": "Bogmannsbrot",
  "item.minecraft.archer_pottery_sherd": "Bogmannsbrot",
  "item.minecraft.armadillo_scute": "Beltisdýrahreistur",
  "item.minecraft.armadillo_spawn_egg": "Beltisdýrsframköllunaregg",
  "item.minecraft.armor_stand": "Brynjustandur",
  "item.minecraft.arms_up_pottery_shard": "Uppgjafarbrot",
  "item.minecraft.arms_up_pottery_sherd": "Uppgjafarbrot",
  "item.minecraft.arrow": "Ör",
  "item.minecraft.axolotl_bucket": "Fata með tálknamöndru",
  "item.minecraft.axolotl_spawn_egg": "Tálknamöndru framköllunaregg",
  "item.minecraft.baked_potato": "Bökuð kartafla",
  "item.minecraft.bamboo_chest_raft": "Bambusfleki með kistu",
  "item.minecraft.bamboo_raft": "Bambusfleki",
  "item.minecraft.bat_spawn_egg": "Leðurblöku framköllunaregg",
  "item.minecraft.bee_spawn_egg": "Býflugu framköllunaregg",
  "item.minecraft.beef": "Hrátt nautakjöt",
  "item.minecraft.beetroot": "Rauðrófa",
  "item.minecraft.beetroot_seeds": "Rauðrófufræ",
  "item.minecraft.beetroot_soup": "Rauðrófusúpa",
  "item.minecraft.birch_boat": "Birkibátur",
  "item.minecraft.birch_chest_boat": "Birkibátur með kistu",
  "item.minecraft.black_bundle": "Svart knippi",
  "item.minecraft.black_dye": "Svart litarefni",
  "item.minecraft.black_harness": "Svartur vomasöðull",
  "item.minecraft.blade_pottery_shard": "Blaðsbrot",
  "item.minecraft.blade_pottery_sherd": "Blaðsbrot",
  "item.minecraft.blaze_powder": "Logaduft",
  "item.minecraft.blaze_rod": "Logateinn",
  "item.minecraft.blaze_spawn_egg": "Loga framköllunaregg",
  "item.minecraft.blue_bundle": "Blátt knippi",
  "item.minecraft.blue_dye": "Blátt litarefni",
  "item.minecraft.blue_egg": "Blátt egg",
  "item.minecraft.blue_harness": "Blár vomasöðull",
  "item.minecraft.bogged_spawn_egg": "Votungsframköllunaregg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Herklæða mynstur - Skrúfboltar",
  "item.minecraft.bone": "Bein",
  "item.minecraft.bone_meal": "Beinamjöl",
  "item.minecraft.book": "Bók",
  "item.minecraft.bordure_indented_banner_pattern": "Skörðóttur rammi fánamynstur",
  "item.minecraft.bow": "Bogi",
  "item.minecraft.bowl": "Skál",
  "item.minecraft.bread": "Brauð",
  "item.minecraft.breeze_rod": "Goluteinn",
  "item.minecraft.breeze_spawn_egg": "Goluframköllunaregg",
  "item.minecraft.brewer_pottery_shard": "Bruggarabrot",
  "item.minecraft.brewer_pottery_sherd": "Bruggarabrot",
  "item.minecraft.brewing_stand": "Bruggstöð",
  "item.minecraft.brick": "Múrsteinn",
  "item.minecraft.brown_bundle": "Brúnt knippi",
  "item.minecraft.brown_dye": "Brúnt litarefni",
  "item.minecraft.brown_egg": "Brúnt egg",
  "item.minecraft.brown_harness": "Brúnn vomasöðull",
  "item.minecraft.brush": "Sópur",
  "item.minecraft.bucket": "Fata",
  "item.minecraft.bundle": "Knippi",
  "item.minecraft.bundle.empty": "Tómt",
  "item.minecraft.bundle.empty.description": "Getur haldið á blönduðum stafla af hlutum",
  "item.minecraft.bundle.full": "Fullt",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Brunabrot",
  "item.minecraft.burn_pottery_sherd": "Brunabrot",
  "item.minecraft.camel_husk_spawn_egg": "Kveikjuegg úlfaldahyskis",
  "item.minecraft.camel_spawn_egg": "Úlfaldaframköllunaregg",
  "item.minecraft.carrot": "Gulrót",
  "item.minecraft.carrot_on_a_stick": "Gulrót á stöng",
  "item.minecraft.cat_spawn_egg": "Kattar framköllunaregg",
  "item.minecraft.cauldron": "Seiðpottur",
  "item.minecraft.cave_spider_spawn_egg": "Hellaköngulóar framköllunaregg",
  "item.minecraft.chainmail_boots": "Hringabrynjustígvél",
  "item.minecraft.chainmail_chestplate": "Hringabrynja",
  "item.minecraft.chainmail_helmet": "Hringabrynjuhjálmur",
  "item.minecraft.chainmail_leggings": "Hringabrynjulegghlífar",
  "item.minecraft.charcoal": "Viðarkol",
  "item.minecraft.cherry_boat": "Kirsuberjabátur",
  "item.minecraft.cherry_chest_boat": "Kirsuberjabátur með kistu",
  "item.minecraft.chest_minecart": "Námuvagn með Kistu",
  "item.minecraft.chicken": "Hrár kjúklingur",
  "item.minecraft.chicken_spawn_egg": "Hænu framköllunaregg",
  "item.minecraft.chorus_fruit": "Kóraldin",
  "item.minecraft.clay_ball": "Leirkúla",
  "item.minecraft.clock": "Klukka",
  "item.minecraft.coal": "Kol",
  "item.minecraft.coast_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Herklæða mynstur - Strönd",
  "item.minecraft.cocoa_beans": "Kakóbaunir",
  "item.minecraft.cod": "Hrár þorskur",
  "item.minecraft.cod_bucket": "Fata með þorski",
  "item.minecraft.cod_spawn_egg": "Þorsks framköllunaregg",
  "item.minecraft.command_block_minecart": "Námuvagn með Forritunarkubbi",
  "item.minecraft.compass": "Áttaviti",
  "item.minecraft.cooked_beef": "Nautasteik",
  "item.minecraft.cooked_chicken": "Eldaður kjúklingur",
  "item.minecraft.cooked_cod": "Eldaður þorskur",
  "item.minecraft.cooked_mutton": "Soðið lambakjöt",
  "item.minecraft.cooked_porkchop": "Eldað svínakjöt",
  "item.minecraft.cooked_rabbit": "Eldað kanínukjöt",
  "item.minecraft.cooked_salmon": "Eldaður lax",
  "item.minecraft.cookie": "Smákaka",
  "item.minecraft.copper_axe": "Koparöxi",
  "item.minecraft.copper_boots": "Koparstígvél",
  "item.minecraft.copper_chestplate": "Koparbrynja",
  "item.minecraft.copper_golem_spawn_egg": "Koparþjarkaframköllunaregg",
  "item.minecraft.copper_helmet": "Koparhjálmur",
  "item.minecraft.copper_hoe": "Koparplógur",
  "item.minecraft.copper_horse_armor": "Koparhestabrynja",
  "item.minecraft.copper_ingot": "Koparhleifur",
  "item.minecraft.copper_leggings": "Koparlegghlífar",
  "item.minecraft.copper_nautilus_armor": "Koparperlusnekkjubrynja",
  "item.minecraft.copper_nugget": "Koparmoli",
  "item.minecraft.copper_pickaxe": "Koparhaki",
  "item.minecraft.copper_shovel": "Koparskófla",
  "item.minecraft.copper_spear": "Koparspjót",
  "item.minecraft.copper_sword": "Koparsverð",
  "item.minecraft.cow_spawn_egg": "Kýrframköllunaregg",
  "item.minecraft.creaking_spawn_egg": "Framköllunaregg brakanda",
  "item.minecraft.creeper_banner_pattern": "Fánamynstur",
  "item.minecraft.creeper_banner_pattern.desc": "Laumupúkamynstur",
  "item.minecraft.creeper_banner_pattern.new": "Laumupúka fánamynstur",
  "item.minecraft.creeper_spawn_egg": "Laumupúka framköllunaregg",
  "item.minecraft.crossbow": "Lásbogi",
  "item.minecraft.crossbow.projectile": "Skeyti:",
  "item.minecraft.crossbow.projectile.multiple": "Skeyti: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Skeyti: %s",
  "item.minecraft.cyan_bundle": "Blágrænt knippi",
  "item.minecraft.cyan_dye": "Lillablár litur",
  "item.minecraft.cyan_harness": "Heiðblár vomasöðull",
  "item.minecraft.danger_pottery_shard": "Hættubrot",
  "item.minecraft.danger_pottery_sherd": "Hættubrot",
  "item.minecraft.dark_oak_boat": "Dökkeikarbátur",
  "item.minecraft.dark_oak_chest_boat": "Dökkeikarbátur með kistu",
  "item.minecraft.debug_stick": "Kembiprik",
  "item.minecraft.debug_stick.empty": "%s hefur enga eiginleika",
  "item.minecraft.debug_stick.select": "valið \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" að %s",
  "item.minecraft.diamond": "Demantur",
  "item.minecraft.diamond_axe": "Demantsöxi",
  "item.minecraft.diamond_boots": "Demantsstígvél",
  "item.minecraft.diamond_chestplate": "Demantsbrynja",
  "item.minecraft.diamond_helmet": "Demantshjálmur",
  "item.minecraft.diamond_hoe": "Demantshlújárn",
  "item.minecraft.diamond_horse_armor": "Demantshestabrynja",
  "item.minecraft.diamond_leggings": "Demantslegghlífar",
  "item.minecraft.diamond_nautilus_armor": "Demantsperlusnekkjubrynja",
  "item.minecraft.diamond_pickaxe": "Demantshaki",
  "item.minecraft.diamond_shovel": "Demantsskófla",
  "item.minecraft.diamond_spear": "Demantsspjót",
  "item.minecraft.diamond_sword": "Demantssverð",
  "item.minecraft.disc_fragment_5": "Disksbrot",
  "item.minecraft.disc_fragment_5.desc": "Tónlistardiskur - 5",
  "item.minecraft.dolphin_spawn_egg": "Höfrungs framköllunaregg",
  "item.minecraft.donkey_spawn_egg": "Asna framköllunaregg",
  "item.minecraft.dragon_breath": "Drekaandi",
  "item.minecraft.dried_kelp": "Þurkað þang",
  "item.minecraft.drowned_spawn_egg": "Druknaðs uppvaknings framköllunaregg",
  "item.minecraft.dune_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Herklæða mynstur - Sandhólar",
  "item.minecraft.echo_shard": "Bergmálsflís",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Öldungarverndara framköllunaregg",
  "item.minecraft.elytra": "Þekjuvængir",
  "item.minecraft.emerald": "Smaragður",
  "item.minecraft.enchanted_book": "Galdrabók",
  "item.minecraft.enchanted_golden_apple": "Galdragullepli",
  "item.minecraft.end_crystal": "Endakristall",
  "item.minecraft.ender_dragon_spawn_egg": "Endadrekaframköllunaregg",
  "item.minecraft.ender_eye": "Endaauga",
  "item.minecraft.ender_pearl": "Endaperla",
  "item.minecraft.enderman_spawn_egg": "Endamanns framköllunaregg",
  "item.minecraft.endermite_spawn_egg": "Endamaursframköllunaregg",
  "item.minecraft.evoker_spawn_egg": "Kraftaskáldsspunaegg",
  "item.minecraft.experience_bottle": "Reynsluflaska",
  "item.minecraft.explorer_pottery_shard": "Landkönnuðarbrot",
  "item.minecraft.explorer_pottery_sherd": "Landkönnuðarbrot",
  "item.minecraft.eye_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Herklæða mynstur - Augað",
  "item.minecraft.feather": "Fjöður",
  "item.minecraft.fermented_spider_eye": "Kæst köngulóarauga",
  "item.minecraft.field_masoned_banner_pattern": "Akur borða fánamynstur",
  "item.minecraft.filled_map": "Kort",
  "item.minecraft.fire_charge": "Eldhnöttur",
  "item.minecraft.firework_rocket": "Raketta",
  "item.minecraft.firework_rocket.flight": "Flugtími",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Flugeldastjarna",
  "item.minecraft.firework_star.black": "Svört ",
  "item.minecraft.firework_star.blue": "Blá",
  "item.minecraft.firework_star.brown": "Brún",
  "item.minecraft.firework_star.custom_color": "Sérsmíðað",
  "item.minecraft.firework_star.cyan": "Heiðblár",
  "item.minecraft.firework_star.fade_to": "Aflitast í",
  "item.minecraft.firework_star.flicker": "Blikandi",
  "item.minecraft.firework_star.gray": "Grá",
  "item.minecraft.firework_star.green": "Græn",
  "item.minecraft.firework_star.light_blue": "Ljósblá",
  "item.minecraft.firework_star.light_gray": "Ljósgrá",
  "item.minecraft.firework_star.lime": "Ljósgrænn",
  "item.minecraft.firework_star.magenta": "Vínrautt",
  "item.minecraft.firework_star.orange": "Appelsínugul",
  "item.minecraft.firework_star.pink": "Bleik",
  "item.minecraft.firework_star.purple": "Fjólublá",
  "item.minecraft.firework_star.red": "Rauð",
  "item.minecraft.firework_star.shape": "Óvitað form",
  "item.minecraft.firework_star.shape.burst": "Hríð",
  "item.minecraft.firework_star.shape.creeper": "Laumupúkalagaður",
  "item.minecraft.firework_star.shape.large_ball": "Stór kúla ",
  "item.minecraft.firework_star.shape.small_ball": "Lítil kúla",
  "item.minecraft.firework_star.shape.star": "Stjörnu-löguð ",
  "item.minecraft.firework_star.trail": "Slóð",
  "item.minecraft.firework_star.white": "Hvít",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Veiðistöng",
  "item.minecraft.flint": "Tinna",
  "item.minecraft.flint_and_steel": "Tinna og Stál",
  "item.minecraft.flow_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Herklæða mynstur - Flæði",
  "item.minecraft.flow_banner_pattern": "Fánamynstur",
  "item.minecraft.flow_banner_pattern.desc": "Flæði",
  "item.minecraft.flow_banner_pattern.new": "Rennslisfánamynstur",
  "item.minecraft.flow_pottery_sherd": "Flæðibrot",
  "item.minecraft.flower_banner_pattern": "Fána mynnstur",
  "item.minecraft.flower_banner_pattern.desc": "Blómamynstur",
  "item.minecraft.flower_banner_pattern.new": "Blómatáknsfánamynstur",
  "item.minecraft.flower_pot": "Blóma Pottur",
  "item.minecraft.fox_spawn_egg": "Refsframköllunaregg",
  "item.minecraft.friend_pottery_shard": "Vinabrot",
  "item.minecraft.friend_pottery_sherd": "Vinabrot",
  "item.minecraft.frog_spawn_egg": "Lífegg frosks",
  "item.minecraft.furnace_minecart": "Námuvagn með Ofni",
  "item.minecraft.ghast_spawn_egg": "Vomsframköllunaregg",
  "item.minecraft.ghast_tear": "Vomstár",
  "item.minecraft.glass_bottle": "Flaska",
  "item.minecraft.glistering_melon_slice": "Glitrandi Melónusneið",
  "item.minecraft.globe_banner_pattern": "Fánamynstur",
  "item.minecraft.globe_banner_pattern.desc": "Hnattmynstur",
  "item.minecraft.globe_banner_pattern.new": "Hnattar fánamynstur",
  "item.minecraft.glow_berries": "Glóber",
  "item.minecraft.glow_ink_sac": "Ljómandi blekpoki",
  "item.minecraft.glow_item_frame": "Glóandi hlutarrammi",
  "item.minecraft.glow_squid_spawn_egg": "Glóandi smokkfisks framköllunaregg",
  "item.minecraft.glowstone_dust": "Glósteinsduft",
  "item.minecraft.goat_horn": "Geitarhorn",
  "item.minecraft.goat_spawn_egg": "Geitar framköllunaregg",
  "item.minecraft.gold_ingot": "Gullhleifur",
  "item.minecraft.gold_nugget": "Gullmoli",
  "item.minecraft.golden_apple": "Gullepli",
  "item.minecraft.golden_axe": "Gullöxi",
  "item.minecraft.golden_boots": "Gullstígvél",
  "item.minecraft.golden_carrot": "Gullrót",
  "item.minecraft.golden_chestplate": "Gullbrynja",
  "item.minecraft.golden_helmet": "Gullhjálmur",
  "item.minecraft.golden_hoe": "Gullplógur",
  "item.minecraft.golden_horse_armor": "Gullhestabrynja",
  "item.minecraft.golden_leggings": "Gulllegghlífar",
  "item.minecraft.golden_nautilus_armor": "Gullperlusnekkjubrynja",
  "item.minecraft.golden_pickaxe": "Gullhaki",
  "item.minecraft.golden_shovel": "Gullskófla",
  "item.minecraft.golden_spear": "Gullspjót",
  "item.minecraft.golden_sword": "Gullsverð",
  "item.minecraft.gray_bundle": "Grátt knippi",
  "item.minecraft.gray_dye": "Grár litur",
  "item.minecraft.gray_harness": "Grár vomasöðull",
  "item.minecraft.green_bundle": "Grænt knippi",
  "item.minecraft.green_dye": "Grænt litarefni",
  "item.minecraft.green_harness": "Grænn vomasöðull",
  "item.minecraft.guardian_spawn_egg": "Verndara framköllunaregg",
  "item.minecraft.gunpowder": "Byssupúður",
  "item.minecraft.guster_banner_pattern": "Fánamynstur",
  "item.minecraft.guster_banner_pattern.desc": "Gustur",
  "item.minecraft.guster_banner_pattern.new": "Gustur fánamynstur",
  "item.minecraft.guster_pottery_sherd": "Gustabrot",
  "item.minecraft.happy_ghast_spawn_egg": "Framköllunaregg hamingjusams voms",
  "item.minecraft.harness": "Vomasöðull",
  "item.minecraft.heart_of_the_sea": "Hjarta hafsins",
  "item.minecraft.heart_pottery_shard": "Hjörtubrot",
  "item.minecraft.heart_pottery_sherd": "Hjörtubrot",
  "item.minecraft.heartbreak_pottery_shard": "Sorgarbrot",
  "item.minecraft.heartbreak_pottery_sherd": "Sorgarbrot",
  "item.minecraft.hoglin_spawn_egg": "Göltungs framköllunaregg",
  "item.minecraft.honey_bottle": "Hunangsflaska",
  "item.minecraft.honeycomb": "Vaxkaka",
  "item.minecraft.hopper_minecart": "Námuvagn með Trekt",
  "item.minecraft.horse_spawn_egg": "Hesta framköllunaregg",
  "item.minecraft.host_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.host_armor_trim_smithing_template.new": "Herklæða mynstur - Gestgafi",
  "item.minecraft.howl_pottery_shard": "Gólsbrot",
  "item.minecraft.howl_pottery_sherd": "Gólsbrot",
  "item.minecraft.husk_spawn_egg": "Sandvakningsframköllunaregg",
  "item.minecraft.ink_sac": "Bleksekkur",
  "item.minecraft.iron_axe": "Járnöxi",
  "item.minecraft.iron_boots": "Járnstígvél",
  "item.minecraft.iron_chestplate": "Járnbrynja",
  "item.minecraft.iron_golem_spawn_egg": "Járnþjarkaframköllunaregg",
  "item.minecraft.iron_helmet": "Járnhjálmur",
  "item.minecraft.iron_hoe": "Járnhlújárn",
  "item.minecraft.iron_horse_armor": "Járnhestabrynja",
  "item.minecraft.iron_ingot": "Járnhleifur",
  "item.minecraft.iron_leggings": "Járnlegghlífar",
  "item.minecraft.iron_nautilus_armor": "Járnperlusnekkjubrynja",
  "item.minecraft.iron_nugget": "Járnmoli",
  "item.minecraft.iron_pickaxe": "Járnhaki",
  "item.minecraft.iron_shovel": "Járnskófla",
  "item.minecraft.iron_spear": "Járnspjót",
  "item.minecraft.iron_sword": "Járnsverð",
  "item.minecraft.item_frame": "Hlutarrammi",
  "item.minecraft.jungle_boat": "Frumskógarviðarbátur",
  "item.minecraft.jungle_chest_boat": "Frumskógarviðarbátur með kistu",
  "item.minecraft.knowledge_book": "Fræðabók",
  "item.minecraft.lapis_lazuli": "Asúrsteinn",
  "item.minecraft.lava_bucket": "Hraunfata",
  "item.minecraft.lead": "Taumur",
  "item.minecraft.leather": "Leður",
  "item.minecraft.leather_boots": "Leðurstígvél",
  "item.minecraft.leather_chestplate": "Leðurjakki",
  "item.minecraft.leather_helmet": "Leðurhattur",
  "item.minecraft.leather_horse_armor": "Leðurhestabrynja",
  "item.minecraft.leather_leggings": "Leðurbuxur",
  "item.minecraft.light_blue_bundle": "Ljósblátt knippi",
  "item.minecraft.light_blue_dye": "Ljósblár litur",
  "item.minecraft.light_blue_harness": "Ljósblár vomasöðull",
  "item.minecraft.light_gray_bundle": "Ljósgrátt knippi",
  "item.minecraft.light_gray_dye": "Ljósgrár litur",
  "item.minecraft.light_gray_harness": "Ljósgrár vomasöðull",
  "item.minecraft.lime_bundle": "Ljósgrænt knippi",
  "item.minecraft.lime_dye": "Ljósgrænn litur",
  "item.minecraft.lime_harness": "Gulgrænn vomasöðull",
  "item.minecraft.lingering_potion": "Langvarandi seyði",
  "item.minecraft.lingering_potion.effect.awkward": "Ankannalegt langvinnt seyði",
  "item.minecraft.lingering_potion.effect.empty": "Langvinnt óbrugganlegt seyði",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Langvinnt seyði eldvarna",
  "item.minecraft.lingering_potion.effect.harming": "Langvinnt seyði skaða",
  "item.minecraft.lingering_potion.effect.healing": "Langvinnt seyði lækningar",
  "item.minecraft.lingering_potion.effect.infested": "Langvinnt Seyði Sýkingar",
  "item.minecraft.lingering_potion.effect.invisibility": "Langvinnt seyði ósýnileika",
  "item.minecraft.lingering_potion.effect.leaping": "Langvinnt seyði stökkkrafts",
  "item.minecraft.lingering_potion.effect.levitation": "Langvinnt seyði svifs",
  "item.minecraft.lingering_potion.effect.luck": "Langvinnt seyði heppni",
  "item.minecraft.lingering_potion.effect.mundane": "Hversdaglegt langvinnt seyði",
  "item.minecraft.lingering_potion.effect.night_vision": "Langvinnt seyði nætursjónar",
  "item.minecraft.lingering_potion.effect.oozing": "Langvinnt seyði slímu",
  "item.minecraft.lingering_potion.effect.poison": "Langvinnt seyði eitrunar",
  "item.minecraft.lingering_potion.effect.regeneration": "Langvinnt seyði endurnýjunar",
  "item.minecraft.lingering_potion.effect.slow_falling": "Langvinnt Seyði af Hægu Falli",
  "item.minecraft.lingering_potion.effect.slowness": "Langvinnt seyði seinagangs",
  "item.minecraft.lingering_potion.effect.strength": "Langvinnt seyði styrkleika",
  "item.minecraft.lingering_potion.effect.swiftness": "Langvinnt seyði snerpu",
  "item.minecraft.lingering_potion.effect.thick": "Þykkt langvinnt seyði",
  "item.minecraft.lingering_potion.effect.turtle_master": "Langvinnt Seyði frá Skjaldböku Meistaranum",
  "item.minecraft.lingering_potion.effect.water": "Langvinn vatnsflaska",
  "item.minecraft.lingering_potion.effect.water_breathing": "Langvinnt seyði vatnsöndunar",
  "item.minecraft.lingering_potion.effect.weakness": "Langvinnt seyði veikleika",
  "item.minecraft.lingering_potion.effect.weaving": "Langvinnt seyði vefnaðar",
  "item.minecraft.lingering_potion.effect.wind_charged": "Langvinnt seyði vindhleðslu",
  "item.minecraft.llama_spawn_egg": "Lamadýrs framköllunaregg",
  "item.minecraft.lodestone_compass": "Vörðuáttaviti",
  "item.minecraft.mace": "Sleggja",
  "item.minecraft.magenta_bundle": "Vínrautt knippi",
  "item.minecraft.magenta_dye": "Vínrauður litur",
  "item.minecraft.magenta_harness": "Vínrauður vomasöðull",
  "item.minecraft.magma_cream": "Kvikukrem",
  "item.minecraft.magma_cube_spawn_egg": "Kvikukubbs framköllunaregg",
  "item.minecraft.mangrove_boat": "Leiruviðarbátur",
  "item.minecraft.mangrove_chest_boat": "Leiruviðarbátur með kistu",
  "item.minecraft.map": "Tómt kort",
  "item.minecraft.melon_seeds": "Melónufræ",
  "item.minecraft.melon_slice": "Melónusneið",
  "item.minecraft.milk_bucket": "Mjólkurfata",
  "item.minecraft.minecart": "Námuvagn",
  "item.minecraft.miner_pottery_shard": "Námumannsbrot",
  "item.minecraft.miner_pottery_sherd": "Námumannsbrot",
  "item.minecraft.mojang_banner_pattern": "Fána mynnstur",
  "item.minecraft.mojang_banner_pattern.desc": "Hlutmynstur",
  "item.minecraft.mojang_banner_pattern.new": "Hluts fánamynstur",
  "item.minecraft.mooshroom_spawn_egg": "Sveppakúar framköllunaregg",
  "item.minecraft.mourner_pottery_shard": "Syrgjandabrot",
  "item.minecraft.mourner_pottery_sherd": "Syrgjandabrot",
  "item.minecraft.mule_spawn_egg": "Múlasnaframköllunaregg",
  "item.minecraft.mushroom_stew": "Sveppasúpa",
  "item.minecraft.music_disc_11": "Hljómplata",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Hljómplata",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Hljómplata",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Hljómplata",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Hljómplata",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Hljómplata",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Hljómplata",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Hljómplata",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Hljómplata",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Hljómplata",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Hljómplata",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Hljómplata",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Hljómplata",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Hljómplata",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Hljómplata",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Hljómplata",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Hljómplata",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Hljómplata",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Hljómplata",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Hljómplata",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Hljómplata",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Hrátt lambakjöt",
  "item.minecraft.name_tag": "Nafnspjald",
  "item.minecraft.nautilus_shell": "Perlusnekkju skel",
  "item.minecraft.nautilus_spawn_egg": "Perlusnekkjuframköllunaregg",
  "item.minecraft.nether_brick": "Heljarmúrsteinn",
  "item.minecraft.nether_star": "Heljarstjarna",
  "item.minecraft.nether_wart": "Heljarvarta",
  "item.minecraft.netherite_axe": "Heljarmálmsöxi",
  "item.minecraft.netherite_boots": "Heljarmálmsstígvél",
  "item.minecraft.netherite_chestplate": "Heljarmálmsbrynja",
  "item.minecraft.netherite_helmet": "Heljarmálmshjálmur",
  "item.minecraft.netherite_hoe": "Heljarmálmshlújárn",
  "item.minecraft.netherite_horse_armor": "Heljarmálmshestabrynja",
  "item.minecraft.netherite_ingot": "Heljarmálmshleifur",
  "item.minecraft.netherite_leggings": "Heljarmálmslegghlífar",
  "item.minecraft.netherite_nautilus_armor": "Heljarmálmsperlusnekkjubrynja",
  "item.minecraft.netherite_pickaxe": "Heljarmálmshaki",
  "item.minecraft.netherite_scrap": "Heljarmálmsbrot",
  "item.minecraft.netherite_shovel": "Heljarmálmsskófla",
  "item.minecraft.netherite_spear": "Heljarmálmsspjót",
  "item.minecraft.netherite_sword": "Heljarmálmssverð",
  "item.minecraft.netherite_upgrade_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Heljarmálmsuppfærsla",
  "item.minecraft.oak_boat": "Eikarbátur",
  "item.minecraft.oak_chest_boat": "Eikarbátur með kistu",
  "item.minecraft.ocelot_spawn_egg": "Villikattar framköllunaregg",
  "item.minecraft.ominous_bottle": "Váboðaflaska",
  "item.minecraft.ominous_trial_key": "Váboðaþrautalykill",
  "item.minecraft.orange_bundle": "Appelsínugult knippi",
  "item.minecraft.orange_dye": "Appelsínugulur litur",
  "item.minecraft.orange_harness": "Appelsínugulur vomasöðull",
  "item.minecraft.painting": "Málverk",
  "item.minecraft.pale_oak_boat": "Föleikarbátur",
  "item.minecraft.pale_oak_chest_boat": "Föleikarbátur með kistu",
  "item.minecraft.panda_spawn_egg": "Pöndu framköllunaregg",
  "item.minecraft.paper": "Blað",
  "item.minecraft.parched_spawn_egg": "Þurrdrumbsframköllunaregg",
  "item.minecraft.parrot_spawn_egg": "Páfagauksframköllunaregg",
  "item.minecraft.phantom_membrane": "Vofuhimna",
  "item.minecraft.phantom_spawn_egg": "Vofu framköllunaregg",
  "item.minecraft.pig_spawn_egg": "Svínsframköllunaregg",
  "item.minecraft.piglin_banner_pattern": "Fána mynnstur",
  "item.minecraft.piglin_banner_pattern.desc": "Trýni",
  "item.minecraft.piglin_banner_pattern.new": "Trýnisfánamynstur",
  "item.minecraft.piglin_brute_spawn_egg": "Svínahrotta framköllunaregg",
  "item.minecraft.piglin_spawn_egg": "Svínungs framköllunaregg",
  "item.minecraft.pillager_spawn_egg": "Ruplara framköllunaregg",
  "item.minecraft.pink_bundle": "Bleikt knippi",
  "item.minecraft.pink_dye": "Bleikur litur",
  "item.minecraft.pink_harness": "Bleikur vomasöðull",
  "item.minecraft.pitcher_plant": "Gildrublaðplanta",
  "item.minecraft.pitcher_pod": "Gildrublaðbelgur",
  "item.minecraft.plenty_pottery_shard": "Gnóttarbrot",
  "item.minecraft.plenty_pottery_sherd": "Gnóttarbrot",
  "item.minecraft.poisonous_potato": "Eitruð kartafla",
  "item.minecraft.polar_bear_spawn_egg": "Ísbjarnarframköllunaregg",
  "item.minecraft.popped_chorus_fruit": "Sprett Kóraldin",
  "item.minecraft.porkchop": "Hrátt svínakjöt",
  "item.minecraft.potato": "Kartafla",
  "item.minecraft.potion": "Seyði",
  "item.minecraft.potion.effect.awkward": "Ankannalegt seyði",
  "item.minecraft.potion.effect.empty": "Óbrugganlegt Seyði",
  "item.minecraft.potion.effect.fire_resistance": "Eldþolseyði",
  "item.minecraft.potion.effect.harming": "Skaðaseyði",
  "item.minecraft.potion.effect.healing": "Heilsuseyði",
  "item.minecraft.potion.effect.infested": "Sýkingaseyði",
  "item.minecraft.potion.effect.invisibility": "Seyði af ósýnileika",
  "item.minecraft.potion.effect.leaping": "Stökkseyði",
  "item.minecraft.potion.effect.levitation": "Svifsseyði",
  "item.minecraft.potion.effect.luck": "Lukkuseyði",
  "item.minecraft.potion.effect.mundane": "Hversdagsseyði",
  "item.minecraft.potion.effect.night_vision": "Seyði af nætursjón",
  "item.minecraft.potion.effect.oozing": "Seyði slímu",
  "item.minecraft.potion.effect.poison": "Eiturseyði",
  "item.minecraft.potion.effect.regeneration": "Endurnæringarseyði",
  "item.minecraft.potion.effect.slow_falling": "Seyði af hægu falli",
  "item.minecraft.potion.effect.slowness": "Slævingsseyði",
  "item.minecraft.potion.effect.strength": "Jötunseyði",
  "item.minecraft.potion.effect.swiftness": "Léttleikaseyði",
  "item.minecraft.potion.effect.thick": "Þykkt seyði",
  "item.minecraft.potion.effect.turtle_master": "Seyði frá Skjaldböku Meistaranum",
  "item.minecraft.potion.effect.water": "Vatnsflaska",
  "item.minecraft.potion.effect.water_breathing": "Köfunarseyði",
  "item.minecraft.potion.effect.weakness": "Veikleikaseyði",
  "item.minecraft.potion.effect.weaving": "Vefnaðarseyði",
  "item.minecraft.potion.effect.wind_charged": "Seyði Vindhleðslu",
  "item.minecraft.pottery_shard_archer": "Bogmannsbrot",
  "item.minecraft.pottery_shard_arms_up": "Uppgjafarbrot",
  "item.minecraft.pottery_shard_prize": "Verðlaunabrot",
  "item.minecraft.pottery_shard_skull": "Hauskúpubrot",
  "item.minecraft.powder_snow_bucket": "Lausamjallarfata",
  "item.minecraft.prismarine_crystals": "Hafsteinskristallar",
  "item.minecraft.prismarine_shard": "Hafsteinsbrot",
  "item.minecraft.prize_pottery_shard": "Verðlaunabrot",
  "item.minecraft.prize_pottery_sherd": "Verðlaunabrot",
  "item.minecraft.pufferfish": "Kúlufiskur",
  "item.minecraft.pufferfish_bucket": "Fata með kúlufisk",
  "item.minecraft.pufferfish_spawn_egg": "Kúlufisksframköllunaregg",
  "item.minecraft.pumpkin_pie": "Graskersbaka",
  "item.minecraft.pumpkin_seeds": "Graskersfræ",
  "item.minecraft.purple_bundle": "Fjólublátt knippi",
  "item.minecraft.purple_dye": "Fjólublár litur",
  "item.minecraft.purple_harness": "Fjólublár vomasöðull",
  "item.minecraft.quartz": "Heljarkvars",
  "item.minecraft.rabbit": "Hrátt kanínukjöt",
  "item.minecraft.rabbit_foot": "Kanínufótur",
  "item.minecraft.rabbit_hide": "Kanínuskinn",
  "item.minecraft.rabbit_spawn_egg": "Kanínuframköllunaregg",
  "item.minecraft.rabbit_stew": "Kanínukássa",
  "item.minecraft.raiser_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Herklæða mynstur - Upprísandi",
  "item.minecraft.ravager_spawn_egg": "Rústara framköllunaregg",
  "item.minecraft.raw_copper": "Hrár kopar",
  "item.minecraft.raw_gold": "Hrátt gull",
  "item.minecraft.raw_iron": "Hrátt járn",
  "item.minecraft.recovery_compass": "Endurheimtaráttaviti",
  "item.minecraft.red_bundle": "Rautt knippi",
  "item.minecraft.red_dye": "Rautt litarefni",
  "item.minecraft.red_harness": "Rauður vomasöðull",
  "item.minecraft.redstone": "Roðsteinsduft",
  "item.minecraft.resin_brick": "Kvoðusteinn",
  "item.minecraft.resin_clump": "Kvoðuköggull",
  "item.minecraft.rib_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Herklæða mynstur - Rifbein",
  "item.minecraft.rotten_flesh": "Rotið hold",
  "item.minecraft.saddle": "Hnakkur",
  "item.minecraft.salmon": "Hrár lax",
  "item.minecraft.salmon_bucket": "Fata með laxi",
  "item.minecraft.salmon_spawn_egg": "Laxframköllunaregg",
  "item.minecraft.scrape_pottery_sherd": "Skrapbrot",
  "item.minecraft.scute": "Hreistur",
  "item.minecraft.sentry_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Herklæða mynstur - Varðmaður",
  "item.minecraft.shaper_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Herklæða mynstur - Mótari",
  "item.minecraft.sheaf_pottery_shard": "Kippubrot",
  "item.minecraft.sheaf_pottery_sherd": "Kippubrot",
  "item.minecraft.shears": "Klippur",
  "item.minecraft.sheep_spawn_egg": "Kindarframköllunaregg",
  "item.minecraft.shelter_pottery_shard": "Skjólsbrot",
  "item.minecraft.shelter_pottery_sherd": "Skjólsbrot",
  "item.minecraft.shield": "Skjöldur",
  "item.minecraft.shield.black": "Svartur skjöldur",
  "item.minecraft.shield.blue": "Blár Skjöldur",
  "item.minecraft.shield.brown": "Brúnn Skjöldur",
  "item.minecraft.shield.cyan": "Blágrænn skjöldur",
  "item.minecraft.shield.gray": "Grár skjöldur",
  "item.minecraft.shield.green": "Grænn Skjöldur",
  "item.minecraft.shield.light_blue": "Ljósblár skjöldur",
  "item.minecraft.shield.light_gray": "Ljósgrár skjöldur",
  "item.minecraft.shield.lime": "Ljósgrænn skjöldur",
  "item.minecraft.shield.magenta": "Vínrauður skjöldur",
  "item.minecraft.shield.orange": "Appelsínugulur skjöldur",
  "item.minecraft.shield.pink": "Bleikur skjöldur",
  "item.minecraft.shield.purple": "Fjólublár skjöldur",
  "item.minecraft.shield.red": "Rauður skjöldur",
  "item.minecraft.shield.white": "Hvítur skjöldur",
  "item.minecraft.shield.yellow": "Gulur skjöldur",
  "item.minecraft.shulker_shell": "Skálksskel",
  "item.minecraft.shulker_spawn_egg": "Framköllunaregg skálks",
  "item.minecraft.sign": "Skilti",
  "item.minecraft.silence_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Herklæða mynstur - Kyrrð",
  "item.minecraft.silverfish_spawn_egg": "Silfurskottu framköllunaregg",
  "item.minecraft.skeleton_horse_spawn_egg": "Beinagandsframköllunaregg",
  "item.minecraft.skeleton_spawn_egg": "Beinagrindarframköllunaregg",
  "item.minecraft.skull_banner_pattern": "Fána mynnstur",
  "item.minecraft.skull_banner_pattern.desc": "Hauskúpumynstur",
  "item.minecraft.skull_banner_pattern.new": "Hauskúpu fánamynstur",
  "item.minecraft.skull_pottery_shard": "Hauskúpubrot",
  "item.minecraft.skull_pottery_sherd": "Hauskúpubrot",
  "item.minecraft.slime_ball": "Slímbolti",
  "item.minecraft.slime_spawn_egg": "Slím framköllunaregg",
  "item.minecraft.smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.smithing_template.applies_to": "Gildir fyrir:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Bæta við málmhleif eða kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Brynja",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Bæta við brynju",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Málmhleifar & Kristallar",
  "item.minecraft.smithing_template.ingredients": "Innihald:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Bæta við heljarmálmshleifi",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Demantsbúnaður",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Bæta við demantsbrynju, vopni eða verkfæri",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Heljarmálmshleifur",
  "item.minecraft.smithing_template.upgrade": "Uppfæra: ",
  "item.minecraft.sniffer_spawn_egg": "Kveikjuegg Þefara",
  "item.minecraft.snort_pottery_shard": "Frýssbrot",
  "item.minecraft.snort_pottery_sherd": "Frýssbrot",
  "item.minecraft.snout_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Herklæða mynstur - Snoppa",
  "item.minecraft.snow_golem_spawn_egg": "Sjókarlsframköllunaregg",
  "item.minecraft.snowball": "Snjóbolti",
  "item.minecraft.spectral_arrow": "Draugaör",
  "item.minecraft.spider_eye": "Köngulóarauga",
  "item.minecraft.spider_spawn_egg": "Köngulóarframköllunaregg",
  "item.minecraft.spire_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Herklæða mynstur - Spírall",
  "item.minecraft.splash_potion": "Skvettiseyði",
  "item.minecraft.splash_potion.effect.awkward": "Ankannalegt skvettiseyði",
  "item.minecraft.splash_potion.effect.empty": "Óbrugganlegt Sprengiseyði",
  "item.minecraft.splash_potion.effect.fire_resistance": "Skvettiseyði eldþols",
  "item.minecraft.splash_potion.effect.harming": "Skvettiseyði skaða",
  "item.minecraft.splash_potion.effect.healing": "Skvettiseyði lækningar",
  "item.minecraft.splash_potion.effect.infested": "Skvettiseyði sýkingar",
  "item.minecraft.splash_potion.effect.invisibility": "Skvettiseyði ósýnileika",
  "item.minecraft.splash_potion.effect.leaping": "Skvettiseyði risastökks",
  "item.minecraft.splash_potion.effect.levitation": "Skvettiseyði svifs",
  "item.minecraft.splash_potion.effect.luck": "Skvettiseyði heppni",
  "item.minecraft.splash_potion.effect.mundane": "Hversdagslegt skvettiseyði",
  "item.minecraft.splash_potion.effect.night_vision": "Skvettiseyði nætursjónar",
  "item.minecraft.splash_potion.effect.oozing": "Skvettiseyði slímu",
  "item.minecraft.splash_potion.effect.poison": "Skvettiseyði eitrunar",
  "item.minecraft.splash_potion.effect.regeneration": "Skvett efni af endurnæringu",
  "item.minecraft.splash_potion.effect.slow_falling": "Skvettiseyði af hægu falli",
  "item.minecraft.splash_potion.effect.slowness": "Skvettiseyði seinfærni",
  "item.minecraft.splash_potion.effect.strength": "Skvettiseyði styrkleika",
  "item.minecraft.splash_potion.effect.swiftness": "Skvettiseyði hraða",
  "item.minecraft.splash_potion.effect.thick": "Þykkt skvettiseyði",
  "item.minecraft.splash_potion.effect.turtle_master": "Skvettiseyði frá Skjaldböku Meistaranum",
  "item.minecraft.splash_potion.effect.water": "Skvetta vatnsflösku",
  "item.minecraft.splash_potion.effect.water_breathing": "Skvett efni af vants öndun",
  "item.minecraft.splash_potion.effect.weakness": "Skvettiseyði veikleika",
  "item.minecraft.splash_potion.effect.weaving": "Skvettiseyði vefa",
  "item.minecraft.splash_potion.effect.wind_charged": "Skvettiseyði vindhleðslu",
  "item.minecraft.spruce_boat": "Grenibátur",
  "item.minecraft.spruce_chest_boat": "Grenibátur með kistu",
  "item.minecraft.spyglass": "Sjónauki",
  "item.minecraft.squid_spawn_egg": "Smokkfisks framköllunaregg",
  "item.minecraft.stick": "Prik",
  "item.minecraft.stone_axe": "Steinöxi",
  "item.minecraft.stone_hoe": "Steinhlújárn",
  "item.minecraft.stone_pickaxe": "Steinhaki",
  "item.minecraft.stone_shovel": "Steinskófla",
  "item.minecraft.stone_spear": "Steinspjót",
  "item.minecraft.stone_sword": "Steinsverð",
  "item.minecraft.stray_spawn_egg": "Útburðarframköllunaregg",
  "item.minecraft.strider_spawn_egg": "Röltara framköllunaregg",
  "item.minecraft.string": "Snæri",
  "item.minecraft.sugar": "Sykur",
  "item.minecraft.suspicious_stew": "Grunsamleg kássa",
  "item.minecraft.sweet_berries": "Sætuber",
  "item.minecraft.tadpole_bucket": "Fata með halakörtu",
  "item.minecraft.tadpole_spawn_egg": "Lífegg halakörtu",
  "item.minecraft.tide_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Herklæða mynstur - Sjávarföll",
  "item.minecraft.tipped_arrow": "Slagsör",
  "item.minecraft.tipped_arrow.effect.awkward": "Dýfð ör",
  "item.minecraft.tipped_arrow.effect.empty": "Ekki iðn Áfengi Ör",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Ör eldþols",
  "item.minecraft.tipped_arrow.effect.harming": "Ör skaða",
  "item.minecraft.tipped_arrow.effect.healing": "Ör lækningar",
  "item.minecraft.tipped_arrow.effect.infested": "Ör sýkingar",
  "item.minecraft.tipped_arrow.effect.invisibility": "Ör ósýnileika",
  "item.minecraft.tipped_arrow.effect.leaping": "Ör risastökks",
  "item.minecraft.tipped_arrow.effect.levitation": "Ör svifs",
  "item.minecraft.tipped_arrow.effect.luck": "Ör heppni",
  "item.minecraft.tipped_arrow.effect.mundane": "Dýfð ör",
  "item.minecraft.tipped_arrow.effect.night_vision": "Ör nætursýnar",
  "item.minecraft.tipped_arrow.effect.oozing": "Ör slímu",
  "item.minecraft.tipped_arrow.effect.poison": "Ör eiturs",
  "item.minecraft.tipped_arrow.effect.regeneration": "Ör endurnýjunar",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Ör hægfara falls",
  "item.minecraft.tipped_arrow.effect.slowness": "Ör hægferðar",
  "item.minecraft.tipped_arrow.effect.strength": "Ör styrks",
  "item.minecraft.tipped_arrow.effect.swiftness": "Ör léttleika",
  "item.minecraft.tipped_arrow.effect.thick": "Dýfð ör",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Ör skjaldbökumeistarans",
  "item.minecraft.tipped_arrow.effect.water": "Ör busls",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Ör köfunar",
  "item.minecraft.tipped_arrow.effect.weakness": "Ör veikleika",
  "item.minecraft.tipped_arrow.effect.weaving": "Ör vefnaðar",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Ör vindhleðslu",
  "item.minecraft.tnt_minecart": "Námuvagn með sprengiefni",
  "item.minecraft.torchflower_seeds": "Kyndilblómsfræ",
  "item.minecraft.totem_of_undying": "Verndargripur tilverunnar",
  "item.minecraft.trader_llama_spawn_egg": "Sölumannslamadýrs framköllunaregg",
  "item.minecraft.trial_key": "Þrautalykill",
  "item.minecraft.trident": "Þríforkur",
  "item.minecraft.tropical_fish": "Hitabeltisfiskur",
  "item.minecraft.tropical_fish_bucket": "Hitabeltisfiskur í fötu",
  "item.minecraft.tropical_fish_spawn_egg": "Hitabeltisfisksframköllunaregg",
  "item.minecraft.turtle_helmet": "Skjaldbökuskel",
  "item.minecraft.turtle_scute": "Hreistur skjaldböku",
  "item.minecraft.turtle_spawn_egg": "Skjaldbökuframköllunaregg",
  "item.minecraft.vex_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Herklæða mynstur - Gremja",
  "item.minecraft.vex_spawn_egg": "Ergisframköllunaregg",
  "item.minecraft.villager_spawn_egg": "Þorpsbúaframköllunaregg",
  "item.minecraft.vindicator_spawn_egg": "Hakkaraframköllunaregg",
  "item.minecraft.wandering_trader_spawn_egg": "Farandsölumannsframköllunaregg",
  "item.minecraft.ward_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Herklæða mynstur - Vörður",
  "item.minecraft.warden_spawn_egg": "Lífegg varðar",
  "item.minecraft.warped_fungus_on_a_stick": "Brenglaður sveppur á stöng",
  "item.minecraft.water_bucket": "Vatnsfata",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Herklæða mynstur - Leiðarvísir",
  "item.minecraft.wheat": "Hveiti",
  "item.minecraft.wheat_seeds": "Hveitifræ",
  "item.minecraft.white_bundle": "Hvítt knippi",
  "item.minecraft.white_dye": "Hvítt litarefni",
  "item.minecraft.white_harness": "Hvítur vomasöðull",
  "item.minecraft.wild_armor_trim_smithing_template": "Járnsmíðasniðmát",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Herklæða mynstur - Villingur",
  "item.minecraft.wind_charge": "Vindhnöttur",
  "item.minecraft.witch_spawn_egg": "Nornarframköllunaregg",
  "item.minecraft.wither_skeleton_spawn_egg": "Viðrinisbeinagrindar framköllunaregg",
  "item.minecraft.wither_spawn_egg": "Viðrinisframköllunaregg",
  "item.minecraft.wolf_armor": "Úlfsbrynja",
  "item.minecraft.wolf_spawn_egg": "Úlfsframköllunaregg",
  "item.minecraft.wooden_axe": "Viðaröxi",
  "item.minecraft.wooden_hoe": "Viðarhlújárn",
  "item.minecraft.wooden_pickaxe": "Viðarhaki",
  "item.minecraft.wooden_shovel": "Viðarskófla",
  "item.minecraft.wooden_spear": "Viðarspjót",
  "item.minecraft.wooden_sword": "Viðarsverð",
  "item.minecraft.writable_book": "Bók og Fjaðurpenni",
  "item.minecraft.written_book": "Skrifuð bók",
  "item.minecraft.yellow_bundle": "Gult knippi",
  "item.minecraft.yellow_dye": "Gult litarefni",
  "item.minecraft.yellow_harness": "Gulur vomasöðull",
  "item.minecraft.zoglin_spawn_egg": "Nágaltar framköllunaregg",
  "item.minecraft.zombie_horse_spawn_egg": "Uppvakningshestsframköllunaregg",
  "item.minecraft.zombie_nautilus_spawn_egg": "Perlusnekkjuuppvakningsframköllunaregg",
  "item.minecraft.zombie_spawn_egg": "Uppvakningsframköllunaregg",
  "item.minecraft.zombie_villager_spawn_egg": "Uppvakningsþorpsbúa framköllunaregg",
  "item.minecraft.zombified_piglin_spawn_egg": "Svíngengils framköllunaregg"
}
export const is_is = items; 
